function go(url) {
  if (window.softNavigate) return window.softNavigate(url);
  window.location.href = url; // fallback si soft-nav pas dispo
}

/* Rejoue l'animation "bande blanche" sur un bouton au clic/tap. */
function sasPlayShine(btn) {
  if (!btn) return;
  btn.classList.remove('sas-shine');
  void btn.offsetWidth;          // force le reflow => l'animation peut rejouer
  btn.classList.add('sas-shine');
  setTimeout(function () { btn.classList.remove('sas-shine'); }, 700);
}

/* Suivi du scroll : sert à NE PAS lancer une instru quand on tape juste pour
   ARRÊTER un scroll lancé (le "flick", fréquent sur Android). */
(function () {
  if (window.__sasScrollTrackerBound) return;
  window.__sasScrollTrackerBound = true;
  window.__sasLastScroll = 0;
  var mark = function () { window.__sasLastScroll = Date.now(); };
  window.addEventListener('scroll', mark, { passive: true, capture: true });
  window.addEventListener('touchmove', mark, { passive: true, capture: true });
})();

/* 🛒 Panier (toggle) : clic sur l'icône => ouvre ; re-clic => ferme. */
(function () {
  if (window.__sasCartToggle) return;
  window.__sasCartToggle = true;
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!cartLink) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return; // pas de tiroir => comportement normal (lien /cart)
    if (drawer.classList.contains('active')) {
      // déjà ouvert => on FERME (et on empêche Dawn de le ré-ouvrir)
      e.preventDefault();
      e.stopImmediatePropagation();
      if (typeof drawer.close === 'function') drawer.close();
      else { drawer.classList.remove('active'); document.body.classList.remove('overflow-hidden'); }
    }
    // sinon (fermé) : on laisse Dawn l'ouvrir normalement
  }, true);
})();

/* ℹ️ Le fondu du MENU BURGER est désormais géré UNIQUEMENT en CSS
   (animations @keyframes sasMenuFadeIn / sasMenuFadeOut dans beat-store.css).
   On a retiré l'ancien fondu en JavaScript (Web Animations API) : son
   "fill: both" laissait l'animation de fermeture collée à opacité 0, ce qui
   rendait le menu INVISIBLE à la réouverture. Le CSS fonctionne très bien sur
   iPhone (même avec "Réduire les animations"), c'est donc plus simple ET fiable. */

/* 📏 Compensation EXACTE du décalage à l'ouverture du menu.
   Quand le menu s'ouvre, l'en-tête passe en position:fixed (retiré du flux).
   On mesure sa hauteur RÉELLE et on la stocke dans --sas-header-comp, que le
   CSS applique en padding-top => le contenu ne bouge plus d'un pixel. */
(function () {
  if (window.__sasHeaderCompBound) return;
  window.__sasHeaderCompBound = true;

  function setHeaderComp() {
    var h = document.querySelector('.section-header')
         || document.querySelector('.shopify-section-header-sticky')
         || document.querySelector('header.header');
    if (!h) return;
    var hh = Math.round(h.getBoundingClientRect().height);
    if (hh > 0) {
      document.documentElement.style.setProperty('--sas-header-comp', hh + 'px');
    }
  }

  setHeaderComp();
  window.addEventListener('DOMContentLoaded', setHeaderComp);
  window.addEventListener('load', setHeaderComp);
  window.addEventListener('resize', setHeaderComp);
  window.addEventListener('orientationchange', function () { setTimeout(setHeaderComp, 100); });
  window.addEventListener('softnav:loaded', setHeaderComp);
  // quelques re-mesures au cas où les polices/logo finissent de charger
  setTimeout(setHeaderComp, 300);
  setTimeout(setHeaderComp, 1000);

  // 🔑 Re-mesure PILE à l'ouverture du menu : c'est là que l'en-tête est à sa
  //    hauteur RÉELLE (fixed, plein). Mesuré à un autre moment il pouvait valoir
  //    une valeur réduite (en-tête rétréci au scroll) => le menu ET le panneau
  //    pays/devise se décalaient / chevauchaient l'en-tête.
  (function () {
    var det = document.getElementById('Details-menu-drawer-container');
    if (!det) return;
    new MutationObserver(function () {
      if (det.hasAttribute('open')) {
        setHeaderComp();
        requestAnimationFrame(setHeaderComp);
        setTimeout(setHeaderComp, 50);
      }
    }).observe(det, { attributes: true, attributeFilter: ['open'] });
  })();
})();

/* ✏️ Liens du MENU MOBILE : trait blanc animé (exactement comme le header PC).
   1) on emballe le texte de chaque lien dans <span class="sas-mlabel"> pour que
      le trait fasse la largeur du mot ; 2) au tap, le trait grandit ;
   3) la page active garde son trait (comme PC). */
(function () {
  if (window.__sasMenuLineBound) return;
  window.__sasMenuLineBound = true;

  function wrap() {
    var links = document.querySelectorAll('.menu-drawer__navigation a.menu-drawer__menu-item');
    Array.prototype.forEach.call(links, function (link) {
      if (link.__sasWrapped) return;
      link.__sasWrapped = true;
      if (!link.querySelector('.sas-mlabel')) {
        var span = document.createElement('span');
        span.className = 'sas-mlabel';
        while (link.firstChild) span.appendChild(link.firstChild);
        link.appendChild(span);
      }
      // feedback au tap : le trait grandit un court instant
      var grow = function () {
        link.classList.add('sas-line-on');
        setTimeout(function () { link.classList.remove('sas-line-on'); }, 600);
      };
      link.addEventListener('pointerdown', grow, { passive: true });
      link.addEventListener('touchstart', grow, { passive: true });
    });
  }

  // Marque le lien de la page COURANTE (le trait blanc reste uniquement sur
  // celle-ci, comme sur PC). On gère AUSSI aria-current : Shopify le pose au
  // chargement mais ne le met pas à jour en navigation douce => sans ça,
  // l'ancienne page gardait son trait. On le retire donc partout sauf sur la
  // page actuelle.
  function norm(p) { p = (p || '').replace(/\/+$/, ''); return p === '' ? '/' : p; }
  function markActive() {
    var path = norm(location.pathname);
    var links = document.querySelectorAll('.menu-drawer__navigation a.menu-drawer__menu-item');
    Array.prototype.forEach.call(links, function (link) {
      try {
        var lp = norm(new URL(link.href).pathname);
        var isCur = (lp === path);
        link.classList.toggle('menu-drawer__menu-item--active', isCur);
        if (isCur) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      } catch (e) {}
    });
  }

  function run() { wrap(); markActive(); }
  run();
  window.addEventListener('DOMContentLoaded', run);
  window.addEventListener('softnav:loaded', run);
  setTimeout(run, 400);
})();

/* 🎬 Démarrage RAPIDE de la vidéo de fond (accueil).
   Le thème la met en preload="metadata" => les données vidéo ne sont PAS
   préchargées, donc au moment de l'autoplay il faut tout télécharger => lent
   (surtout sur mobile). On précharge la vidéo VISIBLE en "auto" et on relance
   play() dès que possible. On ne touche PAS la vidéo cachée => pas de bande
   passante gaspillée, donc pas de latence ajoutée ailleurs. */
(function () {
  if (window.__sasVideoBoost) return;
  window.__sasVideoBoost = true;

  function isVisible(el) {
    // offsetParent === null => display:none (l'autre vidéo desktop/mobile)
    return !!(el && el.offsetParent !== null);
  }

  var SEL = '.mobile-video, .desktop-video, .video-banner video';

  /* iPhone : on bascule sur le flux HLS adaptatif de Shopify (.m3u8).
     Il démarre avec une version LÉGÈRE (480p) puis monte en qualité =>
     démarrage bien plus rapide ET moins de données qu'un mp4 1080p/7,2 Mbps.
     iOS lit le HLS nativement ; Android non => on lui laisse le mp4. */
  function useHlsIfPossible(v) {
    if (!v.canPlayType || !v.canPlayType('application/vnd.apple.mpegurl')) return; // pas iOS
    if (v.__sasHls) return;
    var srcEl = v.querySelector('source');
    var src = (srcEl && (srcEl.src || srcEl.getAttribute('src'))) || v.currentSrc || v.src || '';
    if (!/\.mp4(\?|$)/i.test(src)) return;                 // pas un mp4 (déjà hls ?)
    var clean = src.split('?')[0];
    var hls = clean.replace(/(\/[a-f0-9]{32})\.[^/]*\.mp4$/i, '$1.m3u8');
    if (hls === clean) return;                              // motif non reconnu => on ne touche pas
    v.__sasHls = true;
    v.setAttribute('src', hls);                            // src direct = prioritaire sur <source> sur iOS
    try { v.load(); } catch (e) {}
  }

  function boost() {
    var vids = document.querySelectorAll(SEL);
    Array.prototype.forEach.call(vids, function (v) {
      if (!isVisible(v)) return;            // on ignore la vidéo cachée
      try {
        useHlsIfPossible(v);                            // iPhone => HLS rapide
        if (v.preload !== 'auto') v.preload = 'auto';   // précharge les données
        v.muted = true;                                 // requis pour l'autoplay
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        var p = v.play();
        if (p && p.catch) p.catch(function () {});       // ignore si bloqué
      } catch (e) {}
    });
  }

  boost();
  document.addEventListener('DOMContentLoaded', boost);
  window.addEventListener('load', boost);
  window.addEventListener('pageshow', boost);
  window.addEventListener('softnav:loaded', boost);
  // Dès que la vidéo a assez de données, on (re)lance la lecture tout de suite.
  document.addEventListener('loadeddata', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(SEL) && isVisible(t)) {
      var p = t.play(); if (p && p.catch) p.catch(function () {});
    }
  }, true);
  document.addEventListener('canplay', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(SEL) && isVisible(t)) {
      var p = t.play(); if (p && p.catch) p.catch(function () {});
    }
  }, true);
  // Filet : au 1er contact utilisateur, on relance (certains mobiles bloquent
  // l'autoplay tant qu'il n'y a pas eu d'interaction).
  ['touchstart', 'click'].forEach(function (ev) {
    window.addEventListener(ev, function once() {
      boost();
      window.removeEventListener(ev, once);
    }, { passive: true, once: true });
  });
})();

if (!window.__beatStoreTitleLinkBound) {
  window.__beatStoreTitleLinkBound = true;

  document.addEventListener('click', (e) => {
    const link = e.target.closest('.beat-title-link');
    if (!link) return;

    // ✅ Si le lien est dans une ligne de beat, on laisse la ligne gérer le play
    if (link.closest('.beat-item')) return;

    // laisse les comportements "ouvrir dans un nouvel onglet"
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    go(link.href);
  }, true);
}


class BeatStore {
    constructor() {
        this.currentAudio = null;
        this.currentBeatItem = null;
        this.playerBar = document.getElementById('beatPlayerBar');
        this.playPauseBtn = document.getElementById('playerPlayPause');
        this.playIcon = this.playPauseBtn?.querySelector('.play-icon');
        this.pauseIcon = this.playPauseBtn?.querySelector('.pause-icon');
        this.progressBar = document.querySelector('.progress-bar');
        this.progressFill = document.querySelector('.progress-fill');
        this.playerTime = document.querySelector('.player-time');
        this.playerTrackLink = document.getElementById('playerTrackLink');
        this.progressTooltip = document.getElementById('progressTooltip');
        this.playerCartBtn = document.getElementById('playerCartBtn');
        this.playerCartPrice = document.getElementById('playerCartPrice');
        this.licenseModal = document.getElementById('licenseModal');
        this.currentProductData = null;
        this.selectedLicense = null;

        this.volumeBtn = document.getElementById('playerVolumeBtn');
        this.volumeSliderTrack = document.getElementById('volumeSliderTrack');
        this.volumeSliderContainer = this.volumeSliderTrack?.closest('.volume-slider-container-vertical');
        this.volumeSliderFill = document.getElementById('volumeSliderFill');
        
        this.volumeIcons = {
            normal: document.getElementById('volume-icon-normal'),
            mute: document.getElementById('volume-icon-mute')
        };
        
        this.lastVolume = 70; 
        this.isDraggingVolume = false; 
        this.isMuted = false; 
        this.isMobile = window.innerWidth <= 768; 

        this.beatsPerLoad = parseInt(document.getElementById('beats-per-load-config')?.dataset.beatsPerLoad || 50);
        this.currentlyDisplayedBeats = 0;
        
        this.allBeats = [];
        this.filteredBeats = [];
        this.loadMoreContainer = null;
        this.loadMoreBtn = null;
        this.loadAllBtn = null;

        this.currentSort = { column: 'date', direction: 'desc' };
        // === V1.3 additions ===
        this.seekStep = 5;              // secondes (← / →)
        this.volumeWheelStep = 5;       // % (scroll molette)
        this.isDraggingProgress = false;
        this.wasPlayingBeforeDrag = false;
        this.volumeSliderTimeout = null;


        this.init();

        this.initVolumeControls(); 
        this.initLoadMoreSystem();
    }

    isMobileDevice() {
        return window.innerWidth <= 768;
    }
    

    getCorrectDisplayValue() {
        return this.isMobileDevice() ? 'flex' : 'grid';
    }

    init() {
    this.setupEventListeners();
    this.setupAnimations();

    // Précharge (au repos) les pages produit des beats visibles
    if ('requestIdleCallback' in window) requestIdleCallback(() => this.setupBeatProductPrefetch(), { timeout: 3000 });
    else setTimeout(() => this.setupBeatProductPrefetch(), 1800);

    // === V1.3 additions ===
    this.setupResponsiveListeners();
    this.initKeyboardControls();
    this.initScrollVolumeControl();
    this.initProgressDrag();

    // ✅ bouton play cover
    this.setupProductCoverPlayer();

    // ✅ déplace le bouton Share à côté de BPM/tonalité/date
    this.moveShareNextToMeta();

    if (document.querySelector('.beat-filter-select')) {
        this.setupFilters();
        this.enhanceFilters();
    }

    if (document.querySelector('.beat-search-input')) {
        this.setupSearch();
        this.setupSearchClear();
    }

    this.setupSasReveal();

    this.positionAvailabilityBadge();
    setTimeout(() => this.positionAvailabilityBadge(), 300);
    setTimeout(() => this.positionAvailabilityBadge(), 1000);
    if (!window.__sasAvailabilityResizeBound) {
        window.__sasAvailabilityResizeBound = true;
        window.addEventListener('resize', () => this.positionAvailabilityBadge());
    }
    this.observeAvailabilityBadgeMedia();

    // Marque cette colonne comme "déjà animée" au tout premier chargement,
    // pour ne pas interférer avec l'animation native de Shopify (qui marche au F5).
    // Le retrigger ne s'applique qu'après une navigation interne (refreshDom).
    document.querySelectorAll('.product__info-wrapper.scroll-trigger.animate--slide-in').forEach((el) => {
        el.dataset.sasRevealDone = '1';
    });
}

retriggerProductInfoReveal() {
    document.querySelectorAll('.product__info-wrapper.scroll-trigger.animate--slide-in').forEach((el) => {
        if (el.dataset.sasRevealDone === '1') return;
        el.dataset.sasRevealDone = '1';
        el.classList.add('scroll-trigger--offscreen');
        el.style.setProperty('--animation-order', 0);
        void el.offsetWidth;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                el.classList.remove('scroll-trigger--offscreen');
            });
        });
    });
}

setupSasReveal() {
    let targets = document.querySelectorAll('.sas-reveal:not(.is-sas-visible)');
    if (!targets.length) return;

    // Filet de sécurité : tout élément déjà visible à l'écran au moment de l'appel
    // est révélé immédiatement, sans dépendre du timing de l'IntersectionObserver
    // (qui peut être incohérent selon le moment où le script s'exécute).
    targets.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight && r.width > 0) {
            el.classList.add('is-sas-visible');
        }
    });

    targets = document.querySelectorAll('.sas-reveal:not(.is-sas-visible)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-sas-visible'));
        return;
    }

    if (!this.sasRevealObserver) {
        this.sasRevealObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-sas-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
    }

    targets.forEach((el) => this.sasRevealObserver.observe(el));
}

positionAvailabilityBadge() {
    document.querySelectorAll('.sas-product-cover-shell').forEach((shell) => {
        const badge = shell.querySelector('.sas-availability-badge');
        const media = shell.querySelector('img, video, model-viewer, iframe');
        if (!badge || !media) return;
        const shellRect = shell.getBoundingClientRect();
        const mediaRect = media.getBoundingClientRect();
        const bottomOffset = Math.round(shellRect.bottom - mediaRect.bottom) + 16;
        badge.style.setProperty('bottom', bottomOffset + 'px', 'important');
        badge.classList.add('is-positioned');
    });
}

observeAvailabilityBadgeMedia() {
    if (typeof ResizeObserver === 'undefined') return;
    document.querySelectorAll('.sas-product-cover-shell').forEach((shell) => {
        if (shell.dataset.sasResizeObserved === '1') return;
        shell.dataset.sasResizeObserved = '1';
        const ro = new ResizeObserver(() => this.positionAvailabilityBadge());
        ro.observe(shell);
        shell.querySelectorAll('img, video, model-viewer, iframe').forEach((m) => ro.observe(m));
        // Le swap de média sur changement de variante remplace souvent le noeud <img> :
        // on réattache l'observer périodiquement aux nouveaux médias (sans observer le badge lui-même).
        const reattach = () => {
            shell.querySelectorAll('img, video, model-viewer, iframe').forEach((m) => ro.observe(m));
        };
        if (!document.body.dataset.sasLicenseChangeBound) {
            document.body.dataset.sasLicenseChangeBound = '1';
            document.body.addEventListener('change', (e) => {
                if (!e.target.matches('input[type="radio"]')) return;
                setTimeout(() => { reattach(); this.positionAvailabilityBadge(); }, 50);
                setTimeout(() => { reattach(); this.positionAvailabilityBadge(); }, 300);
            });
        }
    });
}

    setupResponsiveListeners() {
  let resizeTimeout;

  // évite les faux "resize" sur mobile pendant le scroll
  let lastWidth = window.innerWidth;
  let lastIsMobile = this.isMobileDevice();

  window.addEventListener('resize', () => {
    const newWidth = window.innerWidth;
    const isMobileNow = this.isMobileDevice();

    // si ça resize mais qu'on est toujours dans le même mode, on ignore
    if (newWidth === lastWidth && isMobileNow === lastIsMobile) return;

    lastWidth = newWidth;
    lastIsMobile = isMobileNow;

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (document.querySelector('.beat-list')) {
        this.applyFilters();
      }
    }, 250);
  }, { passive: true });
}


    initLoadMoreSystem() {
        this.allBeats = Array.from(document.querySelectorAll('.beat-item:not(#sasGlobalBeatQueue .beat-item):not(#sasProductHiddenBeatQueue .beat-item)'));

        this.allBeats.forEach((beat, index) => {
            if (index >= this.beatsPerLoad) {
                beat.classList.add('beat-hidden-by-loadmore');
            }
        });

        const beatList = document.querySelector('.beat-list');
        if (beatList) {
            beatList.style.opacity = '0';
        }

        if (window.beatStoreConfig && window.beatStoreConfig.needsAjaxLoad) {
            this.loadRemainingBeatsViaAjax().then(() => {
                this.sortAndDisplayAllBeats();
            });
        } else {
            
            this.sortAndDisplayAllBeats();
        }
    }

    async loadRemainingBeatsViaAjax() {
        const collectionHandle = window.beatStoreConfig.collectionHandle;
        const totalProducts = window.beatStoreConfig.totalProducts;
        const productsPerPage = 250;
        const totalPages = Math.ceil(totalProducts / productsPerPage);

        for (let page = 2; page <= totalPages; page++) {
            try {
                const response = await fetch(`/collections/${collectionHandle}?sort_by=created-descending&page=${page}`);

                const html = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newBeats = Array.from(doc.querySelectorAll('.beat-item'));
                
                if (newBeats.length > 0) {
                    
                    const beatList = document.querySelector('.beat-list');
                    newBeats.forEach(beat => {
                        this.allBeats.push(beat);
                        beatList.appendChild(beat);

                        this.attachBeatEventListeners(beat);
                    });
                }
                
            } catch (error) {
                console.error(`❌ Error loading page ${page}:`, error);
            }
        }
    }

    sortAndDisplayAllBeats() {
        const beatList = document.querySelector('.beat-list');
        
        if (beatList && this.allBeats.length > 0) {
            
            this.allBeats.sort((a, b) => {
                let dateA = parseInt(a.dataset.createdDate);
                let dateB = parseInt(b.dataset.createdDate);

                if (!dateA || isNaN(dateA) || dateA === 0) {
                    dateA = Date.now() - 1000000;
                }
                if (!dateB || isNaN(dateB) || dateB === 0) {
                    dateB = Date.now() - 1000000;
                }

                return dateB - dateA;
            });

            beatList.innerHTML = '';
            this.allBeats.forEach(item => {
                beatList.appendChild(item);
            });

            requestAnimationFrame(() => {
                beatList.style.transition = 'opacity 0.3s ease';
                beatList.style.opacity = '1';
            });
        }
        
        this.filteredBeats = [...this.allBeats];

        this.loadMoreContainer = document.querySelector('.beat-load-more-container');
        this.loadMoreBtn = document.querySelector('.beat-load-more-btn');
        this.loadAllBtn = document.querySelector('.beat-load-all-btn');
        
        if (!this.loadMoreBtn) return;

        this.loadMoreBtn.addEventListener('click', () => this.loadMoreBeats());

        if (this.loadAllBtn) {
            this.loadAllBtn.addEventListener('click', () => this.loadAllBeats());
        }
if (typeof this.applyTagParamToSearch === 'function') this.applyTagParamToSearch();

        this.updateVisibleBeats();

        requestAnimationFrame(() => {
            this.setupColumnSort();
        });
    }

    updateVisibleBeats() {
        const beatsToShow = this.currentlyDisplayedBeats + this.beatsPerLoad;

        this.filteredBeats.forEach((beat, index) => {
            if (index < beatsToShow) {
                beat.classList.remove('beat-hidden-by-loadmore');
            } else {
                beat.classList.add('beat-hidden-by-loadmore');
            }
        });

        this.currentlyDisplayedBeats = Math.min(beatsToShow, this.filteredBeats.length);

        this.updateLoadMoreButton();

        this.triggerBeatAnimations();
    }

    loadMoreBeats() {
        if (!this.loadMoreBtn) return;

        this.loadMoreBtn.classList.add('loading');

        setTimeout(() => {
            this.updateVisibleBeats();
            this.loadMoreBtn.classList.remove('loading');
        }, 200);
    }

    loadAllBeats() {
        if (!this.loadAllBtn) return;

        this.loadAllBtn.classList.add('loading');

        setTimeout(() => {
            
            this.currentlyDisplayedBeats = this.filteredBeats.length - this.beatsPerLoad;
            this.updateVisibleBeats();
            this.loadAllBtn.classList.remove('loading');
        }, 200);
    }

    updateLoadMoreButton() {
        if (!this.loadMoreContainer) return;
        
        const hasMoreBeats = this.currentlyDisplayedBeats < this.filteredBeats.length;
        
        if (hasMoreBeats) {
            this.loadMoreContainer.style.display = 'flex';
            
            setTimeout(() => {
                this.loadMoreContainer.classList.add('is-visible');
            }, 100);
        } else {
            this.loadMoreContainer.style.display = 'none';
            this.loadMoreContainer.classList.remove('is-visible');
        }
    }

    triggerBeatAnimations() {
        const visibleBeats = this.filteredBeats.filter((beat, index) =>
            index < this.currentlyDisplayedBeats &&
            !beat.classList.contains('is-visible')
        );
        if (!visibleBeats.length) return;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                // ⚡ Le décalage (stagger) est géré par le CSS (transition-delay),
                // pas par des setTimeout. Résultat : l'entrée reste FLUIDE même si
                // le fil principal est occupé à reconstruire la page (plus de
                // "tout tombe d'un coup"). L'animation tourne sur la carte graphique.
                visibleBeats.forEach((beat, index) => {
                    beat.style.transitionDelay = (index * 30) + 'ms';
                    beat.classList.add('is-visible');
                });
                // On retire le délai une fois l'entrée finie, pour ne pas ralentir le survol.
                const total = visibleBeats.length * 30 + 700;
                setTimeout(() => {
                    visibleBeats.forEach((beat) => { beat.style.transitionDelay = ''; });
                }, total);
            });
        });
    }
    
    setupAnimations() {
        const animatedElements = [
            
            document.querySelector('.beat-store-heading'),
            document.querySelector('.beat-collection-description'),
            document.querySelector('.beat-filters'),
            document.querySelector('.beat-search-container'),
            document.querySelector('.beat-list-header'),

            
        ];

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '0px 0px -20px 0px', 
            threshold: 0.05 
        });

        animatedElements.forEach((el, index) => {
            if (el) {
                el.style.transitionDelay = `${index * 50}ms`;
                observer.observe(el);
            }
        });

    }

    // Précharge la page produit des beats VISIBLES => clic (titre / €34,99)
    // quasi instantané. Limité (cap) et désactivé en éco de données / 2G.
    setupBeatProductPrefetch() {
        const c = navigator.connection;
        if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
        if (typeof window.__sasPrefetch !== 'function') return;

        if (this.__beatPrefetchObs) this.__beatPrefetchObs.disconnect();
        let done = 0;
        const CAP = 8;
        const self = this;
        this.__beatPrefetchObs = new IntersectionObserver((entries) => {
            entries.forEach((en) => {
                if (!en.isIntersecting) return;
                self.__beatPrefetchObs.unobserve(en.target);
                if (done >= CAP) return;
                const h = en.target.dataset && en.target.dataset.productId;
                if (h && !en.target.classList.contains('sas-product-beat-proxy')) {
                    window.__sasPrefetch(location.origin + '/products/' + h);
                    done++;
                }
            });
        }, { rootMargin: '150px 0px' });

        document.querySelectorAll('.beat-item:not(#sasGlobalBeatQueue .beat-item):not(#sasProductHiddenBeatQueue .beat-item)')
            .forEach((b) => self.__beatPrefetchObs.observe(b));
    }

    attachBeatEventListeners(beatItem) {

        beatItem.addEventListener('click', (e) => {
  // Ne pas lancer le player si on clique sur un lien/bouton dans la ligne
  if (e.target.closest('a, button, .beat-title-link, .beat-tag, .beat-cart-btn, .beat-download, .beat-share')) {
    return;
  }

  this.playBeat(beatItem);
});

  // 📱 Tactile fiable : sur mobile, le "click" qui suit un tap est parfois
  // avalé (il faut taper 2 fois). On lance donc l'instru DIRECTEMENT au tap
  // (touchend), exactement comme on l'a fait pour les liens du menu.
  let __sasBeatTapX = 0, __sasBeatTapY = 0;
  beatItem.addEventListener('touchstart', (e) => {
    const t = e.touches && e.touches[0];
    __sasBeatTapX = t ? t.clientX : 0;
    __sasBeatTapY = t ? t.clientY : 0;
  }, { passive: true });
  beatItem.addEventListener('touchend', (e) => {
    // On laisse leur propre logique aux liens/boutons (titre, tag, panier...)
    if (e.target.closest('a, button, .beat-title-link, .beat-tag, .beat-cart-btn, .beat-download, .beat-share')) return;
    // Si on vient de scroller (ou qu'on tape juste pour ARRÊTER un scroll lancé,
    // fréquent sur Android) => ce n'est pas un vrai tap, on ne lance rien.
    if (Date.now() - (window.__sasLastScroll || 0) < 400) return;
    // Si le doigt a bougé => c'était un scroll, on ignore
    const t = e.changedTouches && e.changedTouches[0];
    if (t && (Math.abs(t.clientX - __sasBeatTapX) > 12 || Math.abs(t.clientY - __sasBeatTapY) > 12)) return;
    e.preventDefault();          // empêche le clic fantôme => pas de double déclenchement
    this.playBeat(beatItem);
  }, { passive: false });


        const cartBtn = beatItem.querySelector('.beat-cart-btn');
        if (cartBtn) {
            cartBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                const productHandle = beatItem.dataset.productId;
                if (productHandle) {
                    go(`/products/${productHandle}`);
                } else {
                    console.error('Product list: Product handle not available for redirection.');
                    this.showNotification('Impossible de charger les informations du produit.', 'error');
                }
            });
        }

        const downloadBtn = beatItem.querySelector('.beat-download');
        if (downloadBtn) {
            downloadBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.handleDownload(beatItem);
            });
        }

        const shareBtn = beatItem.querySelector('.beat-share');
        if (shareBtn) {
            shareBtn.addEventListener('click', async (e) => {
                e.stopPropagation();
                const shareUrl = shareBtn.dataset.url;
                if (navigator.share) {
                    try {
                        await navigator.share({
                            title: document.title,
                            url: shareUrl
                        });
                    } catch (error) {
                        console.error('Share failed:', error);
                    }
                } else {
                    
                    navigator.clipboard.writeText(shareUrl).then(() => {
                        this.showNotification('Lien copié dans le presse-papier!', 'success');
                    });
                }
            });
        }

        
    }

    setupEventListeners() {
    // ✅ Binde les lignes une seule fois (évite le double play/pause après refreshDom)
    document.querySelectorAll('.beat-item:not(#sasGlobalBeatQueue .beat-item):not(#sasProductHiddenBeatQueue .beat-item)').forEach(item => {
        if (item.dataset.bsBound === '1') return;
        item.dataset.bsBound = '1';
        this.attachBeatEventListeners(item);
    });

    // ✅ Contrôles player (guard data-bsBound pour éviter le double bind)
    if (this.playPauseBtn && this.playPauseBtn.dataset.bsBound !== '1') {
        this.playPauseBtn.dataset.bsBound = '1';
        this.playPauseBtn.onclick = () => this.togglePlayPause();
    }
    this.syncProductCoverButtonState?.();

    const prevBtn = document.getElementById('playerPrev');
    const nextBtn = document.getElementById('playerNext');
    const closeBtn = document.getElementById('playerClose');

    if (prevBtn && prevBtn.dataset.bsBound !== '1') {
        prevBtn.dataset.bsBound = '1';
        prevBtn.onclick = () => this.playPrevious();
    }
    if (nextBtn && nextBtn.dataset.bsBound !== '1') {
        nextBtn.dataset.bsBound = '1';
        nextBtn.onclick = () => this.playNext();
    }
    if (closeBtn && closeBtn.dataset.bsBound !== '1') {
        closeBtn.dataset.bsBound = '1';
        closeBtn.onclick = () => this.closePlayer();
    }

    // ✅ Progress bar (click + tooltip) bind une seule fois
    if (this.progressBar && this.progressBar.dataset.bsClickBound !== '1') {
        this.progressBar.dataset.bsClickBound = '1';

        this.progressBar.addEventListener('click', (e) => {
            if (this.isDraggingProgress) return;
            if (!this.currentAudio || !this.currentAudio.duration) return;

            const rect = this.progressBar.getBoundingClientRect();
            const percent = (e.clientX - rect.left) / rect.width;
            const clamped = Math.max(0, Math.min(1, percent));
            this.currentAudio.currentTime = clamped * this.currentAudio.duration;
        });

        this.progressBar.addEventListener('mousemove', (e) => this.updateTooltip(e));
        this.progressBar.addEventListener('mouseleave', () => this.hideTooltip());
    }

    // ✅ Panier dans la barre player (handler extrait en méthode pour pouvoir
    //    le re-binder après une navigation douce — voir refreshDom).
    this.bindPlayerCartButton();
}

syncProductCoverButtonState() {
  const btn = document.querySelector('.sas-cover-play-btn');
  const proxyBeat = document.getElementById('sasProductBeatProxy');
  if (!btn || !proxyBeat) return;

  const proxyHandle = proxyBeat.dataset.productId;
  const currentHandle = this.currentBeatItem?.dataset?.productId;

  const isSameProduct = proxyHandle && currentHandle && proxyHandle === currentHandle;
  const isPlaying = !!(isSameProduct && this.currentAudio && !this.currentAudio.paused);

  btn.classList.toggle('is-playing', isPlaying);
}
moveShareNextToMeta() {
  const shareRow = document.querySelector('.sas-share-delivery-row');
  const meta = document.querySelector('.beat-meta');
  if (!shareRow || !meta) return;

  // Déplace le bouton Share dans la ligne BPM/tonalité/date (une seule fois)
  if (shareRow.parentElement !== meta) {
    meta.appendChild(shareRow);
  }
}
positionProductCoverButton() {
  const btn = document.querySelector('.sas-cover-play-btn');
  if (!btn) return;

  // Cible le VRAI conteneur de l'image active Shopify (Dawn)
  const activeMediaContainer =
    document.querySelector('.product__media-list .product__media-item.is-active .product-media-container') ||
    document.querySelector('.product__media-list .product__media-item:first-child .product-media-container') ||
    document.querySelector('.product__media-wrapper .product-media-container') ||
    document.querySelector('.product__media-wrapper .product__media') ||
    document.querySelector('.sas-product-cover-shell');

  if (!activeMediaContainer) return;

  // Important: le bouton doit être positionné dans ce conteneur
  const currentPos = window.getComputedStyle(activeMediaContainer).position;
  if (currentPos === 'static') {
    activeMediaContainer.style.position = 'relative';
  }

  // Déplace le bouton dans l'image (une seule fois)
  if (btn.parentElement !== activeMediaContainer) {
    activeMediaContainer.appendChild(btn);
  }
}
setupProductCoverPlayer() {
  this.positionProductCoverButton?.();

  const btn = document.querySelector('.sas-cover-play-btn');
  const proxyBeat = document.getElementById('sasProductBeatProxy');

  if (!btn || !proxyBeat) return;
  if (btn.dataset.bsBound === '1') {
    this.syncProductCoverButtonState?.();
    return;
  }

  btn.dataset.bsBound = '1';

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const proxyHandle = proxyBeat.dataset.productId;
    const currentHandle = this.currentBeatItem?.dataset?.productId;
    const sameProductLoaded = proxyHandle && currentHandle && proxyHandle === currentHandle && this.currentAudio;

    if (sameProductLoaded) {
      this.togglePlayPause();
      this.syncProductCoverButtonState?.();
      return;
    }

    this.playBeat(proxyBeat);
  });

  this.syncProductCoverButtonState?.();

  // Recale aussi après le rendu complet mobile
  setTimeout(() => this.positionProductCoverButton?.(), 300);
  window.addEventListener('resize', () => this.positionProductCoverButton?.());
}

    closeAllDropdowns() {
        document.querySelectorAll('.select-wrapper.bf-open').forEach(function (w) { w.classList.remove('bf-open'); });
    }

    ensureFilterStyles() {
        if (document.getElementById('bf-filter-styles')) return;
        const style = document.createElement('style');
        style.id = 'bf-filter-styles';
        style.textContent = '.select-wrapper.bf-enhanced::after{display:none !important;}.beat-store-section .beat-filters{position:relative;z-index:50;}.bf-trigger{width:100%;display:flex;align-items:center;justify-content:space-between;gap:10px;padding:13px 16px;border:none;border-radius:12px;cursor:pointer;font-size:15px;font-weight:600;font-family:var(--font-ui,inherit);line-height:1.2;transition:opacity .18s ease;}.bf-trigger:hover{opacity:.92;}.bf-trigger .bf-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}.bf-chev{width:13px;height:13px;flex:0 0 auto;transition:transform .15s ease;}.select-wrapper.bf-open .bf-chev{transform:rotate(180deg);}.bf-panel{position:absolute;top:calc(100% + 8px);left:0;right:0;z-index:60;overflow:hidden;max-height:0;opacity:0;transform:translateY(-8px);pointer-events:none;transition:max-height .15s ease,opacity .12s ease,transform .15s ease;}.select-wrapper.bf-open .bf-panel{max-height:340px;opacity:1;transform:translateY(0);pointer-events:auto;}.bf-panel-inner{background:rgba(18,18,18,.6);-webkit-backdrop-filter:blur(18px) saturate(160%);backdrop-filter:blur(18px) saturate(160%);border:1px solid rgba(255,255,255,.08);border-radius:12px;box-shadow:0 14px 34px rgba(0,0,0,.45);padding:6px;max-height:340px;overflow-y:auto;}.bf-item{padding:11px 14px;border-radius:8px;color:#e9e9e9;font-size:14px;font-weight:500;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:background .14s ease,color .14s ease,padding-left .14s ease;}.bf-item:hover{background:rgba(241,0,0,.16);color:#fff;padding-left:18px;}.bf-item.is-sel{color:#fff;}@media (max-width:768px){.bf-trigger{padding:11px 12px;font-size:14px;}.bf-item{font-size:13px;padding:10px 12px;}}';
        document.head.appendChild(style);
    }

    buildCustomDropdown(select) {
        if (select.dataset.bfEnhanced) return;
        select.dataset.bfEnhanced = '1';
        const wrap = select.closest('.select-wrapper') || select.parentElement;
        if (!wrap) return;
        wrap.classList.add('bf-enhanced');
        if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

        const cs = getComputedStyle(select);
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'bf-trigger';
        trigger.style.backgroundColor = cs.backgroundColor;
        trigger.style.color = cs.color;
        const label = document.createElement('span');
        label.className = 'bf-label';
        trigger.appendChild(label);
        const chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        chev.setAttribute('viewBox', '0 0 24 24');
        chev.setAttribute('class', 'bf-chev');
        chev.innerHTML = '<polyline points="6 9 12 15 18 9" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></polyline>';
        trigger.appendChild(chev);

        const panel = document.createElement('div');
        panel.className = 'bf-panel';
        const inner = document.createElement('div');
        inner.className = 'bf-panel-inner';
        panel.appendChild(inner);

        const sync = function () {
            const cur = select.options[select.selectedIndex];
            label.textContent = cur ? cur.textContent : '';
            Array.prototype.forEach.call(inner.children, function (c) {
                c.classList.toggle('is-sel', c.dataset.value === select.value);
            });
        };

        Array.prototype.forEach.call(select.options, function (opt) {
            const item = document.createElement('div');
            item.className = 'bf-item';
            item.textContent = opt.textContent;
            item.dataset.value = opt.value;
            item.addEventListener('click', function (e) {
                e.stopPropagation();
                select.value = opt.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                sync();
                wrap.classList.remove('bf-open');
            });
            inner.appendChild(item);
        });

        const self = this;
        trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            const willOpen = !wrap.classList.contains('bf-open');
            self.closeAllDropdowns();
            if (willOpen) wrap.classList.add('bf-open');
        });

        wrap.insertBefore(trigger, select);
        wrap.appendChild(panel);
        select.style.display = 'none';
        select.addEventListener('change', sync);
        sync();
    }

    enhanceFilters() {
        if (this.__bfIsIOS === undefined) {
            this.__bfIsIOS = /iP(hone|od|ad)/.test(navigator.userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        }
        if (this.__bfIsIOS) return;
        this.ensureFilterStyles();
        const self = this;
        if (!this.__bfGlobalBound) {
            this.__bfGlobalBound = true;
            document.addEventListener('click', function () { self.closeAllDropdowns(); });
            document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closeAllDropdowns(); });
            // (Retiré) Un MutationObserver surveillait TOUT le <body> et relançait
            // enhanceFilters à CHAQUE changement du DOM (même le temps du lecteur
            // audio qui défile). Très coûteux, et il réorganisait le DOM pile au
            // moment d'un clic => 1er clic "avalé". Les filtres sont déjà
            // ré-initialisés via init() au chargement et sur 'softnav:loaded'.
        }
        document.querySelectorAll('.beat-filter-select').forEach(function (s) { self.buildCustomDropdown(s); });
    }

    setupFilters() {
        this.instrumentSelect = document.querySelector('.beat-filter-select[data-filter="instrument"]');
        this.bpmSelect        = document.querySelector('.beat-filter-select[data-filter="bpm"]');
        this.tagsSelect       = document.querySelector('.beat-filter-select[data-filter="tags"]');

        document.querySelectorAll('.beat-filter-select').forEach(filter => {
            filter.addEventListener('change', () => this.applyFilters());
        });
    }

    setupSearch() {
        const searchInput = document.querySelector('.beat-search-input');
        let searchTimeout;
        searchInput.addEventListener('input', (e) => {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => this.searchBeats(e.target.value), 300);
            this.updateSearchClearVisibility();
            if (e.target.value.trim() === '') {
  try { sessionStorage.removeItem('beatstore_pending_tag'); } catch(e) {}
  const url = new URL(window.location.href);
  if (url.searchParams.has('tag')) {
    url.searchParams.delete('tag');
    window.history.replaceState(
      {},
      '',
      url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '') + url.hash
    );
  }
}

        });
    }

    setupSearchClear() {
        const searchInput = document.querySelector('.beat-search-input');
        const clearButton = document.querySelector('.beat-search-clear');
        
        if (!clearButton || !searchInput) return;

        clearButton.addEventListener('click', () => {
  searchInput.value = '';
  this.searchBeats('');
  this.updateSearchClearVisibility();
  searchInput.focus();

  // enlève le tag persisté
  try { sessionStorage.removeItem('beatstore_pending_tag'); } catch(e) {}

  const url = new URL(window.location.href);
  if (url.searchParams.has('tag')) {
    url.searchParams.delete('tag');
    window.history.replaceState(
      {},
      '',
      url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '') + url.hash
    );
  }
});


        this.updateSearchClearVisibility();
    }
    
    updateSearchClearVisibility() {
        const searchInput = document.querySelector('.beat-search-input');
        const clearButton = document.querySelector('.beat-search-clear');
        
        if (!clearButton || !searchInput) return;
        
        if (searchInput.value.length > 0) {
            clearButton.classList.add('show');
        } else {
            clearButton.classList.remove('show');
        }
    }

    setupColumnSort() {
        const headers = document.querySelectorAll('.beat-header-sortable');
        
        if (headers.length === 0) {
            
            setTimeout(() => this.setupColumnSort(), 100);
            return;
        }
        
        headers.forEach(header => {
            header.addEventListener('click', () => {
                const column = header.dataset.sort;

                if (this.currentSort.column === column) {
                    this.currentSort.direction = this.currentSort.direction === 'asc' ? 'desc' : 'asc';
                } else {
                    this.currentSort.column = column;
                    this.currentSort.direction = 'asc';
                }

                this.updateSortIcons();

                this.sortBeats();
            });
        });
    }

    updateSortIcons() {
        document.querySelectorAll('.beat-header-sortable').forEach(header => {
            const icon = header.querySelector('.sort-icon');
            if (!icon) return;
            
            if (header.dataset.sort === this.currentSort.column) {
                header.classList.add('sorted');
                if (this.currentSort.direction === 'asc') {
                    icon.style.transform = 'rotate(0deg)';
                } else {
                    icon.style.transform = 'rotate(180deg)';
                }
            } else {
                header.classList.remove('sorted');
                icon.style.transform = 'rotate(0deg)';
            }
        });
    }

    sortBeats() {
        const beatList = document.querySelector('.beat-list');
        
        this.filteredBeats.sort((a, b) => {
            let valA, valB;
            
            switch(this.currentSort.column) {
                case 'title':
                    valA = a.dataset.title.toLowerCase();
                    valB = b.dataset.title.toLowerCase();
                    return this.currentSort.direction === 'asc' 
                        ? valA.localeCompare(valB)
                        : valB.localeCompare(valA);
                
                case 'duration':
                    valA = parseInt(a.dataset.durationSeconds || 0);
                    valB = parseInt(b.dataset.durationSeconds || 0);
                    return this.currentSort.direction === 'asc' 
                        ? valA - valB 
                        : valB - valA;
                
                case 'bpm':
                    valA = parseInt(a.dataset.bpm || 0);
                    valB = parseInt(b.dataset.bpm || 0);
                    return this.currentSort.direction === 'asc' 
                        ? valA - valB 
                        : valB - valA;
                
                case 'date':
                default:
                    valA = parseInt(a.dataset.createdDate || 0);
                    valB = parseInt(b.dataset.createdDate || 0);
                    return this.currentSort.direction === 'asc' 
                        ? valA - valB 
                        : valB - valA;
            }
        });

        beatList.innerHTML = '';
        this.filteredBeats.forEach(beat => {
            beatList.appendChild(beat);
        });

        this.currentlyDisplayedBeats = 0;
        this.updateVisibleBeats();
    }

    applyFilters() {
        const filters = {
        instrument: (document.querySelector('[data-filter="instrument"]')?.value || 'all').toLowerCase(),
        bpm: (document.querySelector('[data-filter="bpm"]')?.value || 'all'),
        tags: (document.querySelector('[data-filter="tags"]')?.value || 'all'),
        sort: (document.querySelector('[data-filter="sort"]')?.value || 'default')
    };

        const beatList = document.querySelector('.beat-list');

        this.allBeats.forEach((item, index) => {
            if (!item.dataset.originalOrder) {
                item.dataset.originalOrder = index;
            }
        });

        let visibleBeats = this.allBeats.filter(item => {
            const itemBpm = parseInt(item.dataset.bpm);
            const itemTags = JSON.parse(item.dataset.tags || '[]');
            const itemInstrumentRaw = (item.dataset.instrument || '').toLowerCase();


            const itemInstruments = itemInstrumentRaw
             .split(/[|,]/)
             .map(s => s.trim())
             .filter(Boolean);

            const instrumentMatch =
             filters.instrument === 'all' ||
             itemInstruments.includes(filters.instrument);

            let bpmMatch = filters.bpm === 'all';
            if (!bpmMatch) {
                const bpmSelect = document.querySelector('[data-filter="bpm"]');
                const selectedOption = bpmSelect.querySelector(`option[value="${filters.bpm}"]`);
                
                if (selectedOption) {
                    const minBpm = parseInt(selectedOption.dataset.min || 0);
                    const maxBpm = parseInt(selectedOption.dataset.max || 999);
                    bpmMatch = itemBpm >= minBpm && itemBpm <= maxBpm;
                }
            }

            let tagsMatch = filters.tags === 'all' || itemTags.includes(filters.tags);

            return bpmMatch && tagsMatch && instrumentMatch;
        });

        const sortValue = filters.sort || 'date-desc';
        
        if (sortValue === 'date-desc') {
            visibleBeats.sort((a, b) => {
                const dateA = parseInt(a.dataset.createdDate || 0);
                const dateB = parseInt(b.dataset.createdDate || 0);
                return dateB - dateA;
            });
        } else if (sortValue === 'date-asc') {
            visibleBeats.sort((a, b) => {
                const dateA = parseInt(a.dataset.createdDate || 0);
                const dateB = parseInt(b.dataset.createdDate || 0);
                return dateA - dateB;
            });
        }

        this.allBeats.forEach(item => {
            item.classList.add('hidden');
            item.classList.remove('is-visible');
        });

        beatList.innerHTML = '';
        visibleBeats.forEach(item => {
            item.classList.remove('hidden');
            beatList.appendChild(item);
        });

        this.filteredBeats = visibleBeats;
        this.currentlyDisplayedBeats = 0;
        this.updateVisibleBeats();

        requestAnimationFrame(() => {
            const displayValue = this.isMobileDevice() ? 'flex' : 'grid';
            const toShow = visibleBeats.slice(0, this.currentlyDisplayedBeats)
                .filter((item) => !item.classList.contains('hidden'));
            // Stagger géré par le CSS (transition-delay) => fluide, plus de setTimeout
            toShow.forEach((item, index) => {
                item.style.display = displayValue;
                item.style.transitionDelay = (index * 30) + 'ms';
                item.classList.add('is-visible');
            });
            const total = toShow.length * 30 + 700;
            setTimeout(() => { toShow.forEach((item) => { item.style.transitionDelay = ''; }); }, total);
        });
    }

    normalizeString(str) {
        if (typeof str !== 'string') return '';
        return str
            .toLowerCase()
            .normalize("NFD") 
            .replace(/[\u0300-\u036f]/g, ""); 
    }

    searchBeats(query) {
        const searchTerm = query.toLowerCase().trim();
        const beatList = document.querySelector('.beat-list');

        let matchingBeats = this.allBeats;

        if (searchTerm) {
            matchingBeats = this.allBeats.filter(item => {
                const title = item.dataset.title?.toLowerCase() || '';
                const tags = JSON.parse(item.dataset.tags || '[]').map(t => t.toLowerCase());
                const bpm = item.dataset.bpm || '';

                return title.includes(searchTerm) || 
                    tags.some(tag => tag.includes(searchTerm)) ||
                    bpm.includes(searchTerm);
            });
        }

        this.allBeats.forEach(item => {
            item.classList.add('hidden');
            item.classList.remove('is-visible');
        });

        beatList.innerHTML = '';
        matchingBeats.forEach(item => {
            item.classList.remove('hidden');
            beatList.appendChild(item);
        });

        this.filteredBeats = matchingBeats;
        this.currentlyDisplayedBeats = 0;
        this.updateVisibleBeats();

        requestAnimationFrame(() => {
            const displayValue = this.isMobileDevice() ? 'flex' : 'grid';
            const toShow = matchingBeats.slice(0, this.currentlyDisplayedBeats)
                .filter((item) => !item.classList.contains('hidden'));
            // Stagger géré par le CSS (transition-delay) => fluide, plus de setTimeout
            toShow.forEach((item, index) => {
                item.style.display = displayValue;
                item.style.transitionDelay = (index * 30) + 'ms';
                item.classList.add('is-visible');
            });
            const total = toShow.length * 30 + 700;
            setTimeout(() => { toShow.forEach((item) => { item.style.transitionDelay = ''; }); }, total);
        });
    }

    async playBeat(beatItem) {
        if (beatItem && beatItem.classList && beatItem.classList.contains('sas-product-beat-proxy')) {
  // Le proxy porte déjà son propre audio (le bon, celui du produit affiché).
  // On ne va chercher ailleurs que s'il n'en a vraiment pas.
  if (beatItem.dataset.hasAudio !== '1') {
    const handle = beatItem.dataset.productId;

    if (handle) {
      const realBeat = Array.from(document.querySelectorAll('.beat-item'))
        .find(item =>
          !item.classList.contains('sas-product-beat-proxy') &&
          item.dataset.productId === handle &&
          item.querySelector('.beat-audio')
        );

      if (realBeat) {
        beatItem = realBeat;
      }
    }

    // Toujours pas de correspondance : on ne joue surtout pas le premier
    // audio venu dans la file cachée (ça jouerait le mauvais beat).
    if (beatItem.classList.contains('sas-product-beat-proxy')) return;
  }
}
        const audioElement = beatItem.querySelector('.beat-audio');
        if (!audioElement) return;

        const audioUrl = audioElement.dataset.src || audioElement.querySelector('source')?.src;
        if (!audioUrl) return;

        if (this.currentBeatItem === beatItem && this.currentAudio) {
    this.togglePlayPause();
    return;
}


                // Sauvegarde du volume courant
        if (this.currentAudio) {
            this.lastVolume = Math.round((this.currentAudio.volume || 0.7) * 100);
            this.currentAudio.pause();

            this.currentAudio.onplay = null;
            this.currentAudio.onpause = null;
            this.currentAudio.onended = null;
            this.currentAudio.ontimeupdate = null;
            this.currentAudio.onloadedmetadata = null;
            this.currentAudio.onvolumechange = null;

            this.clearPlayingHighlight();
        }

        const volumeToUse = this.lastVolume || 70;

        // ✅ un seul Audio global, détaché du DOM
        this.currentAudio = new Audio(audioUrl);
        this.currentAudio.preload = 'auto';
        this.currentAudio.volume = volumeToUse / 100;

        this.currentBeatItem = beatItem;

        // ⚡ iOS/iPad : on lance le son IMMÉDIATEMENT (dans le geste du tap),
        // AVANT toute la mise à jour de l'interface, pour que le 1er tap
        // lance bien l'instru du premier coup (sinon iOS bloque le 1er son).
        const thisAudio = this.currentAudio;
        const playPromise = thisAudio.play();

        // Précharge la page produit du beat en cours => clic €34,99 / titre instantané
        try {
            const __ph = beatItem.dataset && beatItem.dataset.productId;
            if (__ph && window.__sasPrefetch) window.__sasPrefetch(location.origin + '/products/' + __ph);
        } catch (e) {}

        this.syncProductCoverButtonState?.();

        this.currentAudio.onplay = () => this.syncProductCoverButtonState?.();
        this.currentAudio.onpause = () => this.syncProductCoverButtonState?.();
        this.currentAudio.onloadedmetadata = () => this.updateTimeDisplay();
        this.currentAudio.ontimeupdate = () => this.updateProgress();
        this.currentAudio.onended = () => {
            this.updatePlayPauseButton(false);
            this.clearPlayingHighlight();
            this.syncProductCoverButtonState?.();
            this.playNext();
        };

        this.currentAudio.onvolumechange = () => {
            if (!this.isDraggingVolume) {
                const newVolumePercent = Math.round(this.currentAudio.volume * 100);
                this.updateVolumeIcon(newVolumePercent);
                if (this.volumeSliderFill) {
                    this.volumeSliderFill.style.height = `${newVolumePercent}%`;
                }
                if (newVolumePercent > 0) {
                    this.lastVolume = newVolumePercent;
                }
            }
        };

              this.updateVolumeIcon(volumeToUse);
        if (this.volumeSliderFill) {
            this.volumeSliderFill.style.height = `${volumeToUse}%`;
        }

        this.updatePlayerUI(beatItem);
        this.setPlayingHighlight(beatItem);
        this.showPlayer();

        try {
            await playPromise;
            if (this.currentAudio === thisAudio) {
                this.updatePlayPauseButton(true);
                this.setPlayingHighlight(beatItem);
            }
        } catch (error) {
            console.error('Play error:', error);
            // Ne nettoie la surbrillance que si ce morceau est toujours le morceau actif
            // (sinon ça efface la surbrillance d'un morceau plus récent lancé entre-temps).
            if (this.currentAudio === thisAudio) {
                this.clearPlayingHighlight();
            }
        }
    }


    showPlayer() {
        this.playerBar.style.display = 'block';
        setTimeout(() => {
            this.playerBar.classList.add('active');
        }, 10);
    }

    closePlayer() {
        if (this.currentAudio) {
            this.currentAudio.pause();
            this.currentAudio = null;
        }

        this.clearPlayingHighlight();
        this.currentBeatItem = null;

        this.playerBar.classList.remove('active');
        setTimeout(() => {
            this.playerBar.style.display = 'none';
        }, 300);
    }

    togglePlayPause() {
        if (!this.currentAudio) return;

        if (this.currentAudio.paused) {
            this.currentAudio.play().then(() => {
                this.updatePlayPauseButton(true);
                this.setPlayingHighlight(this.currentBeatItem);
            });
        } else {
            this.currentAudio.pause();
            this.updatePlayPauseButton(false);
            this.clearPlayingHighlight();
        }
    }
setPlayingHighlight(beatItem) {
  // ✅ Le morceau en cours peut venir d'une file cachée (globale ou produit),
  // donc on met en surbrillance TOUTES les occurrences visibles du même handle.
  document.querySelectorAll('.beat-item.playing').forEach(el => el.classList.remove('playing'));
  if (!beatItem) return;

  const handle = beatItem.dataset?.productId;
  if (!handle) {
    beatItem.classList.add('playing');
    return;
  }

  document.querySelectorAll(`.beat-item[data-product-id="${handle}"]`).forEach(el => {
    el.classList.add('playing');
  });
}

clearPlayingHighlight() {
  document.querySelectorAll('.beat-item.playing').forEach(el => el.classList.remove('playing'));
}

getPlayableBeats() {
  // ✅ File globale (collection BEATZ complète, présente sur toutes les pages) :
  // précédent/suivant restent toujours reliés à la liste complète des instrus,
  // peu importe d'où la lecture a été lancée (Accueil, À propos, page produit...).
  const globalQueueEl = document.getElementById('sasGlobalBeatQueue');
  if (globalQueueEl) {
    const globalQueue = Array.from(globalQueueEl.querySelectorAll('.beat-item'))
      .filter(b => b && b.querySelector('.beat-audio'));

    if (globalQueue.length) return globalQueue;
  }

  const isProductPage = window.location.pathname.includes('/products/');

  // ✅ Sur page produit : utiliser la vraie queue cachée
  if (isProductPage) {
    const productQueue = Array.from(
      document.querySelectorAll('#sasProductHiddenBeatQueue .beat-item.sas-hidden-queue-item')
    ).filter(b => b && b.querySelector('.beat-audio'));

    if (productQueue.length) return productQueue;
  }

  // ✅ Sinon (page BEATZ / home): logique normale
  const source =
    (this.filteredBeats && this.filteredBeats.length)
      ? this.filteredBeats
      : (this.allBeats || []);

  const visible = source.filter(b =>
    b &&
    !b.classList.contains('sas-product-beat-proxy') &&
    !!b.querySelector('.beat-audio') &&
    !b.classList.contains('hidden') &&
    !b.classList.contains('beat-hidden-by-loadmore')
  );

  return visible.length
    ? visible
    : (this.allBeats || []).filter(b =>
        b &&
        !b.classList.contains('sas-product-beat-proxy') &&
        !!b.querySelector('.beat-audio')
      );
}

    findBeatIndex(beats, beatItem) {
  if (!beatItem) return -1;
  const idx = beats.indexOf(beatItem);
  if (idx !== -1) return idx;

  // Repli par handle produit : le morceau en cours peut venir d'une autre
  // liste (Accueil, page produit...) que la file globale BEATZ.
  const handle = beatItem.dataset?.productId;
  if (!handle) return -1;
  return beats.findIndex(b => (b.dataset?.productId || '') === handle);
}

    playNext() {
  const beats = this.getPlayableBeats();
  if (!this.currentBeatItem || beats.length === 0) return;
  if (beats.length === 1) return; // ✅ évite le toggle pause

  const currentIndex = this.findBeatIndex(beats, this.currentBeatItem);
  const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % beats.length;
  this.playBeat(beats[nextIndex]);
}

playPrevious() {
  const beats = this.getPlayableBeats();
  if (!this.currentBeatItem || beats.length === 0) return;

  // ✅ Comportement type Spotify :
  // - si le son a déjà dépassé 5s -> on relance le son actuel depuis le début
  // - sinon -> on passe au son précédent
  const restartThreshold = 5;
  if (this.currentAudio && Number(this.currentAudio.currentTime || 0) >= restartThreshold) {
    this.currentAudio.currentTime = 0;

    // Si le son était en pause, on le relance quand même
    this.currentAudio.play?.().catch(() => {});
    this.updatePlayPauseButton(true);
    this.setPlayingHighlight(this.currentBeatItem);
    return;
  }

  if (beats.length === 1) {
    // 1 seul son dans la queue : on le relance depuis le début
    if (this.currentAudio) {
      this.currentAudio.currentTime = 0;
      this.currentAudio.play?.().catch(() => {});
      this.updatePlayPauseButton(true);
      this.setPlayingHighlight(this.currentBeatItem);
    }
    return;
  }

  const currentIndex = this.findBeatIndex(beats, this.currentBeatItem);
  const prevIndex = currentIndex === -1 ? 0 : (currentIndex - 1 + beats.length) % beats.length;
  this.playBeat(beats[prevIndex]);
}


    updatePlayPauseButton(isPlaying) {
  if (this.playIcon) this.playIcon.style.display = isPlaying ? 'none' : 'block';
  if (this.pauseIcon) this.pauseIcon.style.display = isPlaying ? 'block' : 'none';
}

    updateProgress() {
        if (!this.currentAudio || !this.currentAudio.duration) return;

        // Pendant un glissement manuel, la lecture continue à son ANCIENNE position
        // (le son n'est repositionné qu'au relâchement) : la laisser mettre à jour
        // la barre en même temps que le glissement crée des allers-retours visuels.
        if (this.isDraggingProgress) return;

        const percent = (this.currentAudio.currentTime / this.currentAudio.duration) * 100;

        const customColor = getComputedStyle(this.progressFill).backgroundColor || '#000000';

        this.progressFill.style.cssText = `
            width: ${percent}% !important;
            background-color: ${customColor} !important;
            opacity: 1 !important;
            visibility: visible !important;
            display: block !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            height: 100% !important;
            z-index: 2147483647 !important;
        `;

        this.updateTimeDisplay();
    }


    updateTimeDisplay() {
        if (!this.currentAudio) {
            this.playerTime.textContent = "0:00 / 0:00";
            return;
        }

        const current = this.formatTime(this.currentAudio.currentTime);
        const duration = this.formatTime(this.currentAudio.duration || 0);
        this.playerTime.textContent = `${current} / ${duration}`;
    }

    formatTime(seconds) {
        if (isNaN(seconds)) return '0:00';

        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    }

    updatePlayerUI(beatItem) {
        const title = beatItem.querySelector('.beat-title').textContent;
        const coverImgSrc = beatItem.querySelector('.beat-cover img')?.src;
        const price = beatItem.querySelector('.beat-cart-btn span')?.textContent;
        const productHandle = beatItem.dataset.productId;

        if (this.playerTrackLink) {
  this.playerTrackLink.textContent = title;
  if (productHandle) this.playerTrackLink.href = `/products/${productHandle}`;
}



        const playerAlbumCover = document.getElementById('playerAlbumCover');
        if (coverImgSrc) {
            
            playerAlbumCover.innerHTML = `<img src="${coverImgSrc}" alt="${title}">`;
        } else {
            playerAlbumCover.innerHTML = '<div class="player-album-cover-placeholder"></div>';
        }

        if (this.playerCartBtn && price) {
            if (this.playerCartPrice) {
                this.playerCartPrice.textContent = price;
            }
            this.playerCartBtn.style.display = 'flex';
        }

        this.currentProductData = {
            productHandle: productHandle,
            title: title,
            coverImgSrc: coverImgSrc,
            price: price
        };
    }
    
    updateTooltip(e) {
        if (!this.currentAudio || !this.currentAudio.duration || !this.progressTooltip) return;
    
        const rect = this.progressBar.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const percent = Math.max(0, Math.min(1, x / rect.width));
        const hoverTime = percent * this.currentAudio.duration;
    
        this.progressTooltip.textContent = this.formatTime(hoverTime);
        this.progressTooltip.style.left = `${x}px`;
        this.progressTooltip.style.opacity = '1';
    }

    hideTooltip() {
        if (!this.progressTooltip) return;
        this.progressTooltip.style.opacity = '0';
    }

    async showLicenseModal(beatItem) {
        const productHandle = beatItem.dataset.productId;
        const variantId = beatItem.dataset.variantId;
        const title = beatItem.querySelector('.beat-title').textContent;
        const price = beatItem.querySelector('.beat-cart-btn span')?.textContent;
        const coverImg = beatItem.querySelector('.beat-cover img');

        if (!productHandle) {
            this.showNotification('Erreur: Produit non trouvé', 'error');
            return;
        }

        this.licenseModal.style.display = 'block';
        document.body.style.overflow = 'hidden';

        const modalProductInfo = document.getElementById('modalProductInfo');
        modalProductInfo.innerHTML = `
            <div style="display: flex; align-items: center; gap: 15px;">
                ${coverImg ? `<img src="${coverImg.src}" alt="${title}" style="width: 60px; height: 60px; border-radius: 8px; object-fit: cover;">` : '<div style="width: 60px; height: 60px; background: #333; border-radius: 8px;"></div>'}
                <div>
                    <h3 style="margin: 0 0 5px 0; color: #fff; font-size: 18px;">${title}</h3>
                    <p style="margin: 0; color: #888; font-size: 14px;">Prix de base: ${price}</p>
                </div>
            </div>
        `;

        try {
            const response = await fetch(`/products/${productHandle}.js`);
            const product = await response.json();

            const licenseOptions = document.getElementById('licenseOptions');
            licenseOptions.innerHTML = '';

            product.variants.forEach(variant => {
                const option = document.createElement('div');
                option.className = 'license-option';
                option.dataset.variantId = variant.id;

                const licenseName = variant.title || 'Licence Standard';
                const licensePrice = new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(variant.price / 100);

                option.innerHTML = `
                    <div class="license-option-header">
                        <span class="license-option-name">${licenseName}</span>
                        <span class="license-option-price">${licensePrice}</span>
                    </div>
                    <div class="license-option-description">
                        ${this.getLicenseDescription(licenseName)}
                    </div>
                    ${!variant.available ? '<p class="license-option-unavailable">Non disponible</p>' : ''}
                `;

                if (!variant.available) {
                    option.classList.add('disabled');
                }

                option.addEventListener('click', () => {
                    if (variant.available) {
                        document.querySelectorAll('.license-option').forEach(opt => opt.classList.remove('selected'));
                        option.classList.add('selected');
                        this.selectedLicense = variant;
                    }
                });

                licenseOptions.appendChild(option);
            });

            const addButton = document.createElement('button');
            addButton.className = 'license-add-btn';
            addButton.textContent = 'Ajouter au panier';
            addButton.addEventListener('click', () => this.addToCart());
            licenseOptions.appendChild(addButton);

        } catch (error) {
            console.error('Erreur chargement produit:', error);
            document.getElementById('licenseOptions').innerHTML = '<p class="error-message">Erreur lors du chargement des licences</p>';
        }

        const closeModal = document.getElementById('closeModal');
        const modalOverlay = this.licenseModal.querySelector('.license-modal-overlay');

        const closeHandler = () => {
            this.licenseModal.style.display = 'none';
            document.body.style.overflow = '';
            this.selectedLicense = null;
        };

        closeModal.onclick = closeHandler;
        modalOverlay.onclick = closeHandler;
    }

    getLicenseDescription(licenseName) {
        const descriptions = {
            'Basic': 'Usage personnel uniquement, pas de revente',
            'Premium': 'Usage commercial, jusqu\'à 10,000 copies',
            'Exclusive': 'Droits exclusifs, le beat sera retiré de la vente',
            'Standard': 'Licence d\'utilisation musicale'
        };

        for (const [key, desc] of Object.entries(descriptions)) {
            if (licenseName.toLowerCase().includes(key.toLowerCase())) {
                return desc;
            }
        }

        return 'Licence d\'utilisation musicale';
    }

    async addToCart() {
        if (!this.selectedLicense) {
            alert('Veuillez sélectionner une licence');
            return;
        }

        try {
            
            
const formData = new FormData();
formData.append('id', this.selectedLicense.id);
formData.append('quantity', '1');

// TEST VISUEL (à mettre temporairement)
formData.append('properties[test_unique]', unique);

formData.append('sections', 'cart-drawer,cart-icon-bubble,cart-notification-product,cart-notification-button');

formData.append('sections_url', window.location.pathname);

const response = await fetch('/cart/add.js', {
  method: 'POST',
  body: formData
});

            

            if (!response.ok) {
                throw new Error('Erreur lors de l\'ajout au panier');
            }

            const data = await response.json();

            this.licenseModal.style.display = 'none';
            document.body.style.overflow = '';
            this.selectedLicense = null;

            this.showShopifyNotification(data);

        } catch (error) {
            console.error('Erreur:', error);
            this.showNotification('Erreur lors de l\'ajout au panier', 'error');
        }
    }

    showShopifyNotification(data) {
        const cartNotification = document.querySelector('cart-notification');

        if (cartNotification && cartNotification.renderContents) {
            const parsedState = {
                key: data.items[0].key,
                sections: {}
            };

            if (data.sections) {
                parsedState.sections = data.sections;
            }
            cartNotification.renderContents(parsedState);
            const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer && cartDrawer.renderContents) cartDrawer.renderContents(parsedState);
if (cartDrawer && cartDrawer.open) cartDrawer.open();


        } else {
            const event = new CustomEvent('cart:add', {
                detail: {
                    items: data.items,
                    sections: data.sections
                }
            });
            document.dispatchEvent(event);

            if (data.sections && data.sections['cart-icon-bubble']) {
                this.updateCartBubble(data.sections['cart-icon-bubble']);
            }
            const productTitle = data.items?.[0]?.product_title || 'Produit';
            this.showNotification(`"${productTitle}" ajouté au panier!`, 'success');
        }
    }

    updateCartBubble(bubbleHtml) {
        if (!bubbleHtml) return;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = bubbleHtml;
        const newBubble = tempDiv.querySelector('.cart-count-bubble, .cart-icon-bubble');

        const existingBubbles = document.querySelectorAll('.cart-count-bubble, .cart-icon-bubble');
        existingBubbles.forEach(bubble => {
            if (newBubble && bubble.parentNode) {
                bubble.parentNode.replaceChild(newBubble.cloneNode(true), bubble);
            }
        });
    }

    showNotification(message, type = 'success') {
        const notification = document.createElement('div');
        notification.className = `beat-notification beat-notification--${type}`;
        notification.textContent = message;
        document.body.appendChild(notification);

        setTimeout(() => {
            notification.classList.add('show');
        }, 10);

        setTimeout(() => {
            notification.classList.remove('show');
            setTimeout(() => {
                notification.remove();
            }, 300);
        }, 3000);
    }

    handleDownload(beatItem) {
        
        const popupConfig = document.getElementById('popup-free-download-config');
        if (!popupConfig) {
            this.showNotification('Configuration du popup non trouvée', 'error');
            return;
        }
       
        this.showDownloadPopup({
            title: popupConfig.dataset.popupTitle + ' : ' + title,
            subtitle: popupConfig.dataset.popupSubtitle,
            buttonText: popupConfig.dataset.popupButton,
            coverImg: coverImg,
            beatTitle: title,
            audioUrl: audioUrl
        });
    }

    showDownloadPopup(config) {
        const existingPopup = document.getElementById('free-download-popup');
        if (existingPopup) {
            existingPopup.remove();
        }

        const popup = document.createElement('div');
        popup.id = 'free-download-popup';
        const colorScheme = document.getElementById('popup-free-download-config').dataset.colorScheme || '';
        popup.className = 'free-download-popup ' + colorScheme + ' gradient';
        
        popup.innerHTML = `
            <div class="free-download-popup__content">
                <div class="free-download-popup__bg">
                    ${config.coverImg ? `<img class="free-download-popup__image" src="${config.coverImg}" alt="${config.beatTitle}" onload="this.classList.add('loaded')">` : ''}
                </div>
                
                <button class="free-download-popup__close" type="button">×</button>
                
                <div class="free-download-popup__fields">
                    <h3 class="popup-title">${config.title}</h3>
                    <p class="popup-subtitle">${config.subtitle}</p>
                    
                    <form class="popup-form" data-audio-url="${config.audioUrl}">
                        <div class="popup-field">
                            <label for="popup-firstname">Prénom</label>
                            <input type="text" id="popup-firstname" name="firstName" required>
                        </div>
                        
                        <div class="popup-field">
                            <label for="popup-lastname">Nom</label>
                            <input type="text" id="popup-lastname" name="lastName" required>
                        </div>
                        
                        <div class="popup-field">
                            <label for="popup-email">Adresse e-mail</label>
                            <input type="email" id="popup-email" name="email" required>
                        </div>
                        
                        <div class="popup-privacy">
                            <input type="checkbox" id="popup-privacy" required>
                            <label for="popup-privacy">J'accepte de recevoir des informations par e-mail</label>
                        </div>
                        
                        <button type="submit" class="popup-submit">${config.buttonText}</button>
                    </form>
                </div>
            </div>
        `;

        document.body.appendChild(popup);
        document.body.style.overflow = 'hidden';

        const closeBtn = popup.querySelector('.free-download-popup__close');
        const form = popup.querySelector('.popup-form');
        
        closeBtn.addEventListener('click', () => this.closeDownloadPopup());
        popup.addEventListener('click', (e) => {
            if (e.target === popup) this.closeDownloadPopup();
        });

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.handleDownloadSubmit(form);
        });

        requestAnimationFrame(() => {
            popup.style.opacity = '1';
            popup.style.visibility = 'visible';
        });
    }

    closeDownloadPopup() {
        const popup = document.getElementById('free-download-popup');
        if (popup) {
            popup.style.opacity = '0';
            document.body.style.overflow = '';
            setTimeout(() => {
                popup.remove();
            }, 300);
        }
    }

    async handleDownloadSubmit(form) {
        
        const fd = new FormData(form);
        const firstName = fd.get('firstName') || fd.get('first_name') || fd.get('popup-firstname') || '';
        const lastName  = fd.get('lastName')  || fd.get('last_name')  || fd.get('popup-lastname') || '';
        const email     = fd.get('email')     || fd.get('emailAddress') || fd.get('popup-email') || '';
        const beatTitle = (document.querySelector('.popup-title')?.innerText) || (fd.get('beatTitle')) || 'Unknown Beat';
        const audioUrl  = form.dataset.audioUrl || '';

        const payload = {
            beatTitle: beatTitle,
            email: email,
            name: (firstName + ' ' + lastName).trim(),
            lang: navigator.language || navigator.userLanguage || 'en',
            downloadUrl: audioUrl
        };

        console.log('Payload envoyé à Google Script :', payload);

        const GAS_URL = 'https://script.google.com/macros/s/xxxxxxxxxxxx/exec';

        try {
            const iframeName = 'gsPostFrame';
            let iframe = document.querySelector(`iframe[name="${iframeName}"]`);
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.name = iframeName;
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
            }

            const postForm = document.createElement('form');
            postForm.method = 'POST';
            postForm.action = GAS_URL;
            postForm.target = iframeName;
            postForm.style.display = 'none';

            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'data';
            input.value = JSON.stringify(payload);
            postForm.appendChild(input);

            document.body.appendChild(postForm);
            postForm.submit();

            setTimeout(() => postForm.remove(), 2500);

            this.showNotification("Merci ! Le lien de téléchargement a été envoyé par e-mail.", "success");
        } catch (err) {
            console.error('iframe POST failed, fallback fetch', err);

            try {
                await fetch(GAS_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    body: new URLSearchParams({ data: JSON.stringify(payload) })
                });
                this.showNotification("Merci ! Le lien de téléchargement a été envoyé par e-mail.", "success");
            } catch (err2) {
                console.error('Fallback fetch failed', err2);
                this.showNotification("Une erreur est survenue. Réessayez plus tard.", "error");
            }
        }

        this.closeDownloadPopup();
    }

    initVolumeControls() {
        if (!this.volumeBtn || !this.volumeSliderTrack) return;

        const volumeControl = this.volumeBtn.closest('.player-volume-control');
        let sliderShowTimeout;

        const preventDefaults = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };

        const clearStuckStates = () => {
            this.volumeBtn.style.transform = '';
            this.volumeBtn.style.backgroundColor = '';
            this.volumeBtn.blur(); 

            this.volumeBtn.offsetHeight;
        };

        const setVolumeFromEvent = (e) => {
            if (!this.currentAudio) return;
            
            const trackRect = this.volumeSliderTrack.getBoundingClientRect();
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            let volumePercent = ((trackRect.bottom - clientY) / trackRect.height) * 100;
            volumePercent = Math.max(0, Math.min(100, volumePercent));
            
            this.setVolume(volumePercent);
        };

        if (!this.isMobileDevice()) {
            this.volumeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                clearStuckStates();
                
                if (!this.currentAudio) return;
                
                if (this.currentAudio.volume > 0) {
                    this.lastVolume = this.currentAudio.volume * 100;
                    this.setVolume(0);
                } else {
                    const volumeToRestore = this.lastVolume > 5 ? this.lastVolume : 70;
                    this.setVolume(volumeToRestore);
                }
            });

            volumeControl.addEventListener('mouseenter', () => {
                clearTimeout(sliderShowTimeout);
                volumeControl.classList.add('show-slider');
            });

            volumeControl.addEventListener('mouseleave', () => {
                sliderShowTimeout = setTimeout(() => {
                    volumeControl.classList.remove('show-slider');
                }, 200);
            });

        } else {
            
            this.volumeBtn.addEventListener('touchstart', preventDefaults, { passive: false });
            this.volumeBtn.addEventListener('touchend', (e) => {
                preventDefaults(e);
                clearStuckStates();
                
                if (volumeControl.classList.contains('show-slider')) {
                    volumeControl.classList.remove('show-slider');
                } else {
                    volumeControl.classList.add('show-slider');
                }
            }, { passive: false });

            document.addEventListener('touchstart', (e) => {
                if (!volumeControl.contains(e.target)) {
                    volumeControl.classList.remove('show-slider');
                }
            });
        }

        let isDragging = false;

        const startDrag = (e) => {
            isDragging = true;
            this.isDraggingVolume = true;
            setVolumeFromEvent(e);
            
            if (e.type === 'touchstart') {
                preventDefaults(e);
            }
        };

        const moveDrag = (e) => {
            if (isDragging) {
                setVolumeFromEvent(e);
                if (e.type === 'touchmove') {
                    preventDefaults(e);
                }
            }
        };

        const endDrag = () => {
            isDragging = false;
            this.isDraggingVolume = false;
        };

        this.volumeSliderTrack.addEventListener('mousedown', startDrag);
        this.volumeSliderTrack.addEventListener('touchstart', startDrag, { passive: false });
        
        document.addEventListener('mousemove', moveDrag);
        document.addEventListener('touchmove', moveDrag, { passive: false });
        
        document.addEventListener('mouseup', endDrag);
        document.addEventListener('touchend', endDrag);

        this.setVolume(70);
    }
    
    setVolume(volume) {
      const newVolume = Math.max(0, Math.min(100, volume));

      if (newVolume > 0) {
        this.lastVolume = newVolume;
      }

      if (this.volumeSliderFill) {
        const volumeFillColor = getComputedStyle(this.volumeSliderFill).backgroundColor || '#f5deb3';
        this.volumeSliderFill.style.cssText = `
           height: ${newVolume}% !important;
                background-color: ${volumeFillColor} !important;
                opacity: 1 !important;
                visibility: visible !important;
                display: block !important;
                position: absolute !important;
                bottom: 0 !important;
                left: 0 !important;
                width: 100% !important;
                z-index: 2147483647 !important;
        `;
      }

      this.updateVolumeIcon(newVolume);

      if (!this.currentAudio) return;

      this.currentAudio.volume = newVolume / 100;
      this.isMuted = (newVolume === 0);

    }
   
    updateVolumeIcon(volume) {
        if (!this.volumeIcons.normal || !this.volumeIcons.mute) {
            return;
        }
        
        this.volumeIcons.normal.style.display = 'none';
        this.volumeIcons.mute.style.display = 'none';

        if (volume === 0) {
            this.volumeIcons.mute.style.display = 'block';
        } else {
            this.volumeIcons.normal.style.display = 'block';
        }
    }
    // ============================
// V1.3 — Keyboard shortcuts
// ============================
initKeyboardControls() {
  if (this._keyboardListenerAttached) return;
  this._keyboardListenerAttached = true;

  document.addEventListener(
    'keydown',
    (e) => {
      const tag = (e.target?.tagName || '').toLowerCase();
      const isTyping =
        ['input', 'textarea', 'select'].includes(tag) || e.target?.isContentEditable;

      if (isTyping) return;

      // Space / arrows are the only ones we care about
      const code = e.code;

      if (code === 'Space') {
        e.preventDefault();
        this.togglePlayPause();
        return;
      }

      if (!code.startsWith('Arrow')) return;

      // If no track loaded yet, allow Up/Down anyway (it will try to move selection)
      e.preventDefault();

      if (code === 'ArrowUp') {
        this.playPrevious();
      } else if (code === 'ArrowDown') {
        this.playNext();
      } else if (code === 'ArrowLeft') {
        this.seekRelative(-this.seekStep);
      } else if (code === 'ArrowRight') {
        this.seekRelative(this.seekStep);
      }
    },
    { passive: false }
  );
}

seekRelative(deltaSeconds) {
  if (!this.currentAudio || !this.currentAudio.duration) return;

  const nextTime = this.currentAudio.currentTime + deltaSeconds;
  this.currentAudio.currentTime = Math.max(0, Math.min(this.currentAudio.duration, nextTime));
}

// ============================
// V1.3 — Scroll to change volume
// ============================
initScrollVolumeControl() {
  const volumeControl = this.volumeBtn?.closest('.player-volume-control');
  if (!volumeControl) return;

  const onWheel = (e) => {
    if (!this.currentAudio) return;

    e.preventDefault();

    const current = Math.round((this.currentAudio.volume || 0) * 100);
    const delta = e.deltaY < 0 ? this.volumeWheelStep : -this.volumeWheelStep; // wheel up = louder
    const next = current + delta;

    this.setVolume(next);

    // Show slider briefly for feedback
    volumeControl.classList.add('show-slider');
    clearTimeout(this.volumeSliderTimeout);
    this.volumeSliderTimeout = setTimeout(() => {
      volumeControl.classList.remove('show-slider');
    }, 900);
  };

  volumeControl.addEventListener('wheel', onWheel, { passive: false });
}

// ============================
// V1.3 — Drag progress bar
// ============================
initProgressDrag() {
  if (!this.progressBar) return;

  const seekToClientX = (clientX) => {
    if (!this.currentAudio || !this.currentAudio.duration) return;

    const rect = this.progressBar.getBoundingClientRect();
    const percent = (clientX - rect.left) / rect.width;
    const clamped = Math.max(0, Math.min(1, percent));
    const targetTime = clamped * this.currentAudio.duration;

    // Pendant le glissement, on ne bouge QUE l'affichage (barre + temps).
    // Le son, lui, ne bouge qu'une seule fois au relâchement (voir commitPendingSeek) :
    // le repositionner à chaque pixel de mouvement le faisait craquer/grésiller.
    if (this.progressFill) {
      this.progressFill.style.width = (clamped * 100) + '%';
    }
    if (this.playerTime) {
      this.playerTime.textContent = `${this.formatTime(targetTime)} / ${this.formatTime(this.currentAudio.duration)}`;
    }

    this._sasPendingSeekTime = targetTime;
  };

  const commitPendingSeek = () => {
    if (this._sasPendingSeekTime != null && this.currentAudio) {
      this.currentAudio.currentTime = this._sasPendingSeekTime;
      this._sasPendingSeekTime = null;
    }
  };

  const start = (clientX) => {
    if (!this.currentAudio || !this.currentAudio.duration) return;

    this.isDraggingProgress = true;
    this.wasPlayingBeforeDrag = !this.currentAudio.paused;

    // ✅ On ne met plus en pause pendant le drag
    this.progressBar.classList.add('is-dragging');
    seekToClientX(clientX);
  };

  const move = (clientX) => {
    if (!this.isDraggingProgress) return;
    seekToClientX(clientX);
  };

  const end = () => {
    if (!this.isDraggingProgress) return;

    this.isDraggingProgress = false;
    this.progressBar.classList.remove('is-dragging');
    commitPendingSeek(); // position finale exacte, même si le dernier seek a été throttlé

    // ✅ Pas de relance play() ici, car on n’a jamais mis en pause
    this.wasPlayingBeforeDrag = false;
  };

  // Mouse
  this.progressBar.addEventListener('mousedown', (e) => {
    e.preventDefault(); // évite les comportements parasites
    start(e.clientX);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp, { once: true });
  });

  const onMouseMove = (e) => move(e.clientX);
  const onMouseUp = () => {
    document.removeEventListener('mousemove', onMouseMove);
    end();
  };

  // Touch
  this.progressBar.addEventListener(
    'touchstart',
    (e) => {
      if (!e.touches?.length) return;
      start(e.touches[0].clientX);
    },
    { passive: true }
  );

  this.progressBar.addEventListener(
    'touchmove',
    (e) => {
      if (!this.isDraggingProgress || !e.touches?.length) return;
      move(e.touches[0].clientX);
    },
    { passive: true }
  );

  this.progressBar.addEventListener('touchend', () => end(), { passive: true });

  // Si le navigateur annule le geste (ex: il le prend pour un scroll quand le
  // doigt sort trop du cadre), 'touchend' ne se déclenche PAS => sans ce
  // listener, le curseur restait bloqué en "glissement" en arrière-plan.
  this.progressBar.addEventListener('touchcancel', () => end(), { passive: true });

  // Filet de sécurité pour la souris : si le clic est relâché en dehors de la
  // fenêtre du navigateur, ou si l'onglet perd le focus pendant le glissement.
  window.addEventListener('blur', () => {
    if (this.isDraggingProgress) {
      document.removeEventListener('mousemove', onMouseMove);
      end();
    }
  });
}

}
// ===== BeatStore singleton + refresh pour soft-nav =====
(function () {
  // Ajoute refreshDom une seule fois
  if (!BeatStore.prototype.refreshDom) {

    // ===== Bouton panier €34,99 de la barre player =====
    // Mis dans une méthode pour pouvoir le (re)binder DEUX fois :
    //  - au chargement (setupEventListeners)
    //  - après une navigation douce (refreshDom), car soft-nav remplace le DOM
    //    => sans ça, le bouton ne marchait QUE après un rafraîchissement.
    BeatStore.prototype.bindPlayerCartButton = function () {
      if (!this.playerCartBtn || this.playerCartBtn.dataset.bsBound === '1') return;
      this.playerCartBtn.dataset.bsBound = '1';

      const goToProduct = () => {
        let handle = this.currentProductData && this.currentProductData.productHandle;
        if (!handle && this.currentBeatItem) handle = this.currentBeatItem.dataset.productId;
        if (handle) {
          go(`/products/${handle}`);
        } else {
          this.showNotification('Impossible de charger les informations du produit.', 'error');
        }
      };

      let __pcNavLock = false;
      const triggerPlayerNav = () => {
        if (__pcNavLock) return;
        __pcNavLock = true;
        sasPlayShine(this.playerCartBtn);
        setTimeout(() => { __pcNavLock = false; goToProduct(); }, 320);
      };
      this.playerCartBtn.onclick = (e) => { e.stopPropagation(); triggerPlayerNav(); };
      this.playerCartBtn.addEventListener('touchend', (e) => { e.stopPropagation(); triggerPlayerNav(); }, { passive: true });

      const preloadProduct = () => {
        const handle = (this.currentProductData && this.currentProductData.productHandle)
          || (this.currentBeatItem && this.currentBeatItem.dataset && this.currentBeatItem.dataset.productId);
        if (handle && window.__sasPrefetch) window.__sasPrefetch('/products/' + handle);
      };
      this.playerCartBtn.addEventListener('mouseenter', preloadProduct);
      this.playerCartBtn.addEventListener('touchstart', preloadProduct, { passive: true });
    };

    BeatStore.prototype.refreshDom = function () {
              // ===== Re-capter les refs du player (soft-nav remplace le DOM) =====
      this.playerBar = document.getElementById('beatPlayerBar');
      this.playPauseBtn = document.getElementById('playerPlayPause');
      this.playIcon = this.playPauseBtn?.querySelector('.play-icon') || null;
      this.pauseIcon = this.playPauseBtn?.querySelector('.pause-icon') || null;
      this.progressBar = document.querySelector('.progress-bar');
      this.progressFill = document.querySelector('.progress-fill');
      this.playerTime = document.querySelector('.player-time');
      this.playerTrackLink = document.getElementById('playerTrackLink');
      this.progressTooltip = document.getElementById('progressTooltip');
      this.playerCartBtn = document.getElementById('playerCartBtn');
      this.playerCartPrice = document.getElementById('playerCartPrice');

      this.volumeBtn = document.getElementById('playerVolumeBtn');
      this.volumeSliderTrack = document.getElementById('volumeSliderTrack');
      this.volumeSliderContainer = this.volumeSliderTrack?.closest('.volume-slider-container-vertical');
      this.volumeSliderFill = document.getElementById('volumeSliderFill');

      this.volumeIcons = {
        normal: document.getElementById('volume-icon-normal'),
        mute: document.getElementById('volume-icon-mute')
      };

      // Rebind des boutons de la barre (1 fois par nouveau DOM)
      const prevBtn = document.getElementById('playerPrev');
      const nextBtn = document.getElementById('playerNext');
      const closeBtn = document.getElementById('playerClose');

      if (this.playPauseBtn && this.playPauseBtn.dataset.bsBound !== '1') {
        this.playPauseBtn.dataset.bsBound = '1';
        this.playPauseBtn.onclick = () => this.togglePlayPause();
      }

      if (prevBtn && prevBtn.dataset.bsBound !== '1') {
        prevBtn.dataset.bsBound = '1';
        prevBtn.onclick = () => this.playPrevious();
      }

      if (nextBtn && nextBtn.dataset.bsBound !== '1') {
        nextBtn.dataset.bsBound = '1';
        nextBtn.onclick = () => this.playNext();
      }

      if (closeBtn && closeBtn.dataset.bsBound !== '1') {
        closeBtn.dataset.bsBound = '1';
        closeBtn.onclick = () => this.closePlayer();
      }

      // ✅ Re-binde le bouton panier €34,99 (sinon il ne marchait qu'après refresh)
      this.bindPlayerCartButton();

      // Rebind click sur barre de progression
      if (this.progressBar && this.progressBar.dataset.bsClickBound !== '1') {
        this.progressBar.dataset.bsClickBound = '1';

        this.progressBar.addEventListener('click', (e) => {
          if (this.isDraggingProgress) return;
          if (!this.currentAudio || !this.currentAudio.duration) return;

          const rect = this.progressBar.getBoundingClientRect();
          const percent = (e.clientX - rect.left) / rect.width;
          const clamped = Math.max(0, Math.min(1, percent));
          this.currentAudio.currentTime = clamped * this.currentAudio.duration;
        });

        this.progressBar.addEventListener('mousemove', (e) => this.updateTooltip(e));
        this.progressBar.addEventListener('mouseleave', () => this.hideTooltip());
      }

      // Rebind drag de la progress bar (une fois par nouveau DOM)
      if (this.progressBar && this.progressBar.dataset.bsDragBound !== '1') {
        this.progressBar.dataset.bsDragBound = '1';
        this.initProgressDrag();
      }
      // Re-scan beats (si la nouvelle page n'a pas de liste de beats, on garde
      // l'ancienne liste en mémoire pour que suivant/précédent continuent de marcher)
      const scannedBeats = Array.from(document.querySelectorAll(".beat-item:not(#sasGlobalBeatQueue .beat-item):not(#sasProductHiddenBeatQueue .beat-item)"));
      if (scannedBeats.length) {
        this.allBeats = scannedBeats;
        this.filteredBeats = [...this.allBeats];
      }
            // Si soft-nav a remplacé le DOM, currentBeatItem peut pointer vers un ancien node
      if (this.currentBeatItem && this.allBeats.length) {
        const oldHandle = this.currentBeatItem.dataset?.productId || '';
        const oldTitle =
          this.currentBeatItem.dataset?.title ||
          this.currentBeatItem.querySelector('.beat-title')?.textContent?.trim() ||
          '';

        const normalizeUrl = (u) => {
          try { return new URL(u, window.location.origin).pathname; } catch (e) { return (u || '').split('?')[0]; }
        };

        const currentAudioPath = this.currentAudio?.src ? normalizeUrl(this.currentAudio.src) : '';
        let remapped = null;

        if (oldHandle) {
          remapped = this.allBeats.find(b =>
  (b.dataset?.productId || '') === oldHandle &&
  !b.classList.contains('sas-product-beat-proxy')
) || null;
        }

        if (!remapped && currentAudioPath) {
          remapped = this.allBeats.find(b => {
            const el = b.querySelector('.beat-audio');
            const src = el?.dataset?.src || el?.querySelector('source')?.src || '';
            return src && normalizeUrl(src) === currentAudioPath;
          }) || null;
        }

        if (!remapped && oldTitle) {
          remapped = this.allBeats.find(b => {
            const t = b.dataset?.title || b.querySelector('.beat-title')?.textContent?.trim() || '';
            return t === oldTitle;
          }) || null;
        }

        if (remapped) {
          this.currentBeatItem = remapped;
        }

        if (this.currentAudio && !this.currentAudio.paused) {
          this.setPlayingHighlight(this.currentBeatItem);
        }
      }
      // ✅ Si on a navigué et que le currentBeatItem vient d'une ancienne page,
// on le remappe vers le beat équivalent dans le nouveau DOM
if (this.currentBeatItem && !document.contains(this.currentBeatItem)) {
  const currentHandle = this.currentBeatItem.dataset?.productId;
  if (currentHandle) {
    const remapped = this.allBeats.find(item =>
      item.dataset?.productId === currentHandle &&
      !item.classList.contains('sas-product-beat-proxy')
    );
    if (remapped) {
      this.currentBeatItem = remapped;
    }
  }
}
      // ✅ Re-tri après soft-nav (sinon Shopify peut afficher "best-selling")
const beatList = document.querySelector(".beat-list");
if (beatList && this.allBeats.length) {
  this.allBeats.sort((a, b) => {
    const dateA = parseInt(a.dataset.createdDate || 0, 10);
    const dateB = parseInt(b.dataset.createdDate || 0, 10);
    return dateB - dateA; // récent -> ancien
  });

  beatList.innerHTML = "";
  this.allBeats.forEach((el) => beatList.appendChild(el));
  this.filteredBeats = [...this.allBeats];
}

      // Refresh refs DOM (soft-nav remplace les éléments => anciennes refs invalides)
this.instrumentSelect = document.querySelector('.beat-filter-select[data-filter="instrument"]');
this.bpmSelect = document.querySelector('.beat-filter-select[data-filter="bpm"]');
this.tagsSelect = document.querySelector('.beat-filter-select[data-filter="tags"]');


      // Re-capter les nouveaux selects (après soft-nav le DOM change)
this.instrumentSelect = document.querySelector('.beat-filter-select[data-filter="instrument"]');
this.bpmSelect        = document.querySelector('.beat-filter-select[data-filter="bpm"]');
this.tagsSelect       = document.querySelector('.beat-filter-select[data-filter="tags"]');
this.sortSelect       = document.querySelector('.beat-filter-select[data-filter="sort"]');

      // Rebind events sur chaque beat (1 seule fois)
      this.allBeats.forEach((item) => {
        if (item.dataset.bsBound === "1") return;
        item.dataset.bsBound = "1";
        this.attachBeatEventListeners(item);
      });

      // Refait apparaître les éléments (sinon opacity:0 => écran vide)
      document
        .querySelectorAll(
          ".beat-store-heading, .beat-collection-description, .beat-filters, .beat-search-container, .beat-list-header"
        )
        .forEach((el) => el && el.classList.add("is-visible"));

      // Les beat-item gardent leur animation d'entrée (stagger), pas d'apparition instantanée
      this.triggerBeatAnimations();

      // Re-setup animations (pour les beats qui arrivent au scroll)
      this.setupAnimations();

      // Précharge (au repos) les pages produit des beats visibles
      if ('requestIdleCallback' in window) requestIdleCallback(() => this.setupBeatProductPrefetch(), { timeout: 3000 });
      else setTimeout(() => this.setupBeatProductPrefetch(), 1800);

      // Repositionne le badge "DISPONIBLE" sur la cover produit après navigation soft-nav
      this.positionAvailabilityBadge();
      this.observeAvailabilityBadgeMedia();
      setTimeout(() => this.positionAvailabilityBadge(), 50);
      setTimeout(() => this.positionAvailabilityBadge(), 400);

      // Redéplace le bouton Share à côté de BPM/tonalité/date après navigation soft-nav
      this.moveShareNextToMeta();
      setTimeout(() => this.moveShareNextToMeta(), 50);
      setTimeout(() => this.moveShareNextToMeta(), 400);

      // Relance l'animation d'apparition de la colonne prix/licences après navigation soft-nav
      this.retriggerProductInfoReveal();
      this.setupSasReveal();

      // Rebind filtres / search (sans empiler 50 listeners)
      const filters = document.querySelectorAll(".beat-filter-select");
      filters.forEach((f) => (f.onchange = () => this.applyFilters()));

      this.enhanceFilters();

      const searchInput = document.querySelector(".beat-search-input");
      if (searchInput) {
        clearTimeout(this.__searchT);
        searchInput.oninput = (e) => {
          clearTimeout(this.__searchT);
          this.__searchT = setTimeout(() => this.searchBeats(e.target.value), 300);
          this.updateSearchClearVisibility();
        };
      }

      const clearBtn = document.querySelector(".beat-search-clear");
      if (clearBtn && searchInput) {
        clearBtn.onclick = () => {
          searchInput.value = "";
          this.searchBeats("");
          this.updateSearchClearVisibility();
          searchInput.focus();
        };
      }

      // Load more buttons (si présents)
      this.loadMoreContainer = document.querySelector(".beat-load-more-container");
      this.loadMoreBtn = document.querySelector(".beat-load-more-btn");
      this.loadAllBtn = document.querySelector(".beat-load-all-btn");

      if (this.loadMoreBtn) this.loadMoreBtn.onclick = () => this.loadMoreBeats();
      if (this.loadAllBtn) this.loadAllBtn.onclick = () => this.loadAllBeats();

      // Remet le système "visible beats" au propre
      this.beatsPerLoad = parseInt(
        document.getElementById("beats-per-load-config")?.dataset.beatsPerLoad || 50
      );
      this.currentlyDisplayedBeats = 0;
      this.updateVisibleBeats();
      if (typeof this.applyTagParamToSearch === "function") this.applyTagParamToSearch();

    };
  }
  
// Appliquer automatiquement ?tag=... dans la barre de recherche
if (!BeatStore.prototype.applyTagParamToSearch) {
  BeatStore.prototype.applyTagParamToSearch = function () {
    const searchInput = document.querySelector('.beat-search-input');
    if (!searchInput) return;

    const params = new URLSearchParams(window.location.search);
    let tag = params.get('tag') || sessionStorage.getItem('beatstore_pending_tag');
    if (!tag) return;

    try { tag = decodeURIComponent(tag.replace(/\+/g, ' ')); } catch(e) {}

    searchInput.value = tag;
    this.searchBeats(tag);
    if (typeof this.updateSearchClearVisibility === "function") {
      this.updateSearchClearVisibility();
    }

    sessionStorage.removeItem('beatstore_pending_tag');

    
  };
}

// Clique sur un tag (partout sur le site) — FIX HARD
if (!window.__beatTagClickBound) {
  window.__beatTagClickBound = true;

  // IMPORTANT: window + capture => on passe avant tous les autres scripts
  window.addEventListener("click", (e) => {
    const tagEl = e.target.closest(".beat-tag");
    if (!tagEl) return;

    const tagText = (tagEl.getAttribute("data-tag-value") || tagEl.textContent || "").trim();
    if (!tagText) return;

    // bloque TOUT: plus de navigation native, plus de scroll bizarre d'un autre handler
    e.preventDefault();
    e.stopImmediatePropagation();

    const searchInput = document.querySelector(".beat-search-input");

    // Si on est déjà sur BEATZ: on filtre et on remonte en haut
    if (searchInput && window.__beatStore && document.querySelector(".beat-store-section")) {
  searchInput.value = tagText;

  window.__beatStore.searchBeats(tagText);
  window.__beatStore.updateSearchClearVisibility?.();

  requestAnimationFrame(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  });

  return;
}

    // Sinon: on va sur BEATZ (softNavigate si dispo) et on applique via ?tag=
    try { sessionStorage.setItem("beatstore_pending_tag", tagText); } catch (err) {}
    go(`/collections/beatz?tag=${encodeURIComponent(tagText)}`);
  }, true);
}



    function runSasRevealStandalone() {
  const targets = document.querySelectorAll('.sas-reveal:not(.is-sas-visible)');
  if (!targets.length) return;

  targets.forEach((el) => {
    const r = el.getBoundingClientRect();
    if (r.bottom > 0 && r.top < window.innerHeight && r.width > 0) {
      el.classList.add('is-sas-visible');
    }
  });

  const remaining = document.querySelectorAll('.sas-reveal:not(.is-sas-visible)');
  if (!remaining.length) return;

  if (!('IntersectionObserver' in window)) {
    remaining.forEach((el) => el.classList.add('is-sas-visible'));
    return;
  }

  if (!window.__sasRevealStandaloneObserver) {
    window.__sasRevealStandaloneObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-sas-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
  }

  remaining.forEach((el) => window.__sasRevealStandaloneObserver.observe(el));
}

    function bootBeatStore() {
  const hasPlayer = !!document.getElementById("beatPlayerBar");
  const hasBeats = !!document.querySelector(".beat-item");
  const hasCoverBtn = !!document.querySelector(".sas-cover-play-btn");
  const hasReveal = !!document.querySelector(".sas-reveal");

  if (!hasPlayer && !hasBeats && !hasCoverBtn) {
    if (hasReveal) runSasRevealStandalone();
    return;
  }

  if (!window.__beatStore) {
    window.__beatStore = new BeatStore();

    setTimeout(() => {
      window.__beatStore.refreshDom?.();
      window.__beatStore.setupProductCoverPlayer?.();
    }, 0);

    return;
  }

  setTimeout(() => {
    window.__beatStore.refreshDom?.();
    window.__beatStore.setupProductCoverPlayer?.();
  }, 0);
}

    


    

document.addEventListener("DOMContentLoaded", bootBeatStore);
window.addEventListener("softnav:loaded", bootBeatStore);
document.addEventListener("shopify:section:load", bootBeatStore);


window.addEventListener("softnav:loaded", function() {
    if (window.location.pathname.indexOf('/products/') !== -1) return;
    document.querySelectorAll('product-modal, .product-media-modal').forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
    });
});



})();
/* =====================================================
   SAS NAV FIX — sync onglet actif après soft-nav
   ===================================================== */
(function () {
  const MENU_SEL = "header .header__inline-menu";
  const ACTIVE_CLASS = "header__active-menu-item";

  function normalize(path) {
    path = (path || "/").split("?")[0].split("#")[0];
    if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);
    return path;
  }

  // enlève /en, /fr, /en-us, etc.
  function stripLocale(path) {
    path = normalize(path);
    const m = path.match(/^\/[a-z]{2}(?:-[a-z]{2})?(\/|$)/i);
    if (!m) return path;
    const stripped = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?/i, "");
    return normalize(stripped || "/");
  }

  function getLinks() {
    const menu = document.querySelector(MENU_SEL);
    if (!menu) return [];
    return Array.from(menu.querySelectorAll("a[href]"));
  }

  function clearActive(links) {
    links.forEach(a => {
      a.classList.remove(ACTIVE_CLASS);
      if (a.getAttribute("aria-current") === "page") a.removeAttribute("aria-current");
    });
  }

  function pickBestLink(links) {
    const currentRaw = normalize(location.pathname);
    const current = stripLocale(currentRaw);

    let best = null;
    let bestLen = -1;

    for (const a of links) {
      const href = a.getAttribute("href");
      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) continue;

      let pRaw;
      try { pRaw = normalize(new URL(href, location.origin).pathname); }
      catch { continue; }

      const p = stripLocale(pRaw);

      const ok =
        currentRaw === pRaw || currentRaw.startsWith(pRaw + "/") ||
        current === p || current.startsWith(p + "/");

      if (ok && p.length > bestLen) {
        best = a;
        bestLen = p.length;
      }
    }

    return best;
  }

  function syncActive() {
    const links = getLinks();
    if (!links.length) return;

    clearActive(links);

    const best = pickBestLink(links);
    if (best) {
      best.classList.add(ACTIVE_CLASS);
      best.setAttribute("aria-current", "page");
    }
  }

  function scheduleSync() {
    syncActive();
    setTimeout(syncActive, 50);
    setTimeout(syncActive, 250);
    setTimeout(syncActive, 800);
  }

  // ✅ au clic : feedback immédiat (et on resync derrière)
  document.addEventListener("click", (e) => {
    const a = e.target.closest(MENU_SEL + " a[href]");
    if (!a) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

    const links = getLinks();
    clearActive(links);
    a.classList.add(ACTIVE_CLASS);
    a.setAttribute("aria-current", "page");

    scheduleSync();
  }, true);

  // ✅ load normal
  document.addEventListener("DOMContentLoaded", scheduleSync);
  window.addEventListener("pageshow", scheduleSync);
  window.addEventListener("popstate", scheduleSync);

  // ✅ soft-nav event (le tien existe déjà dans tes scripts)
  window.addEventListener("softnav:loaded", scheduleSync);

  // ✅ patch history (si soft-nav change l’URL sans event)
  ["pushState", "replaceState"].forEach(fn => {
    const orig = history[fn];
    history[fn] = function () {
      const ret = orig.apply(this, arguments);
      scheduleSync();
      return ret;
    };
  });
})();

// ===========================
// FIX viewport mobile (iOS/Android)
// -> calcule un offset quand la barre navigateur apparaît
// -> applique un mouvement doux (pas de "saut")
// ===========================
(function () {
  const bar = document.querySelector('.beat-player-bar');
  if (!bar) return;

  // On prend la plus grande innerHeight observée comme référence (barre navigateur "rangée")
  let maxH = window.innerHeight || 0;
  let raf = null;

  function update() {
    // Met à jour la référence si on a un viewport plus grand (barre navigateur cachée)
    maxH = Math.max(maxH, window.innerHeight || 0);

    // Quand la barre navigateur apparaît -> innerHeight diminue -> delta > 0
    const delta = Math.max(0, maxH - (window.innerHeight || 0));

    document.documentElement.style.setProperty('--toolbar-offset', `${delta}px`);
    raf = null;
  }

  function requestUpdate() {
    if (raf) return;
    raf = requestAnimationFrame(update);
  }

  // Events qui changent la hauteur visible sur mobile
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('scroll', requestUpdate, { passive: true });

  // iOS / Android modernes
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', requestUpdate, { passive: true });
    window.visualViewport.addEventListener('scroll', requestUpdate, { passive: true });
  }

  // Premier calcul
  update();
})();

function go(url) {
  if (window.softNavigate) return window.softNavigate(url);
  window.location.href = url;

}


/* (Retiré) Bloc de debug qui faisait un fetch + console.table des variantes
   sur CHAQUE page produit. Inutile en production, il ralentissait l'ouverture
   des fiches produit pour rien. */



/* ============================================================
   CORRECTIF PANIER LICENCES (ajouté) — force au panier la licence
   affichée en ROUGE (cochée), en interceptant /cart/add.
   Global + persiste en navigation rapide.
   ============================================================ */
(function(){
  if (window.__sasLicenseCart) return;
  window.__sasLicenseCart = true;

  function selectedVariantId(){
    var pill = document.querySelector('.product-form__input--pill');
    if (!pill) return null;
    var r = pill.querySelector('.license-card input[type="radio"]:checked')
         || pill.querySelector('.license-card.is-recommended input[type="radio"]');
    if (!r) return null;
    var vid = r.getAttribute('data-variant-id');
    return vid ? String(vid) : null;
  }
  function isCartAdd(url){ return typeof url === 'string' && url.indexOf('/cart/add') > -1; }
  function patchBody(body, vid){
    if (!body) return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData){ body.set('id', vid); return body; }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams){ body.set('id', vid); return body; }
    if (typeof body === 'string'){
      try{
        var o = JSON.parse(body);
        if (o && typeof o === 'object'){
          if ('id' in o) o.id = isNaN(+vid) ? vid : +vid;
          if (Array.isArray(o.items)) o.items = o.items.map(function(it){ it.id = isNaN(+vid)?vid:+vid; return it; });
          return JSON.stringify(o);
        }
      }catch(e){
        if (/(^|&)id=/.test(body)) return body.replace(/(^|&)id=[^&]*/, '$1id=' + encodeURIComponent(vid));
      }
    }
    return body;
  }
  if (window.fetch){
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      try{
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (isCartAdd(url)){
          var vid = selectedVariantId();
          if (vid && init && init.body) init.body = patchBody(init.body, vid);
        }
      }catch(e){}
      return _fetch.apply(this, arguments);
    };
  }
  if (window.XMLHttpRequest){
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__isCartAdd = isCartAdd(url);
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(body){
      try{
        if (this.__isCartAdd){
          var vid = selectedVariantId();
          if (vid) { body = patchBody(body, vid); }
        }
      }catch(e){}
      return _send.call(this, body);
    };
  }
  function syncHidden(){
    var vid = selectedVariantId(); if (!vid) return;
    document.querySelectorAll(
      'form[id^="product-form-"] input[name="id"], form[action*="/cart/add"] input[name="id"], input.product-variant-id'
    ).forEach(function(i){ i.value = vid; i.removeAttribute('disabled'); });
  }
  document.addEventListener('change', function(e){
    if (e.target && e.target.closest && e.target.closest('.product-form__input--pill .license-card')) syncHidden();
  });
  document.addEventListener('DOMContentLoaded', syncHidden);
  document.addEventListener('shopify:section:load', syncHidden);
  window.addEventListener('load', syncHidden);
})();
